const FormPageData = [
  {
    id: 1000,
    form: `create-deal-sheet`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/deal-sheet/create-deal-sheet-1.png",
    description: `The deal sheet acts as your confirmation of the transaction 
    details, including commission. Staff use it to generate your Trade Record 
    Sheets for signing. Follow the steps below to easily generate 
    your deal sheet from the details in SkySlope.`,
    hotspots: [],
  },
  {
    id: 1001,
    form: `ResidentialPurchaseContract`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-1.png",
    description: `<p>The Residential Purchase Contract stands as 
    the primary document employed in acquiring residential resale properties. As you 
    complete this contract, it is imperative to cross-reference all property 
    details with secondary sources. While the listing 
    agent bears the responsibility of ensuring listing accuracy, it remains crucial 
    to undertake thorough due diligence for your client, refraining from solely 
    depending on the listing information.
     </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyers & Sellers:</strong> Ensure that you input the complete legal names of both Buyers and 
        Sellers. Take the extra step of cross-referencing your clients' IDs to 
        guarantee accuracy. If the client is a corporation, be sure to obtain 
        documents, such as the Articles of Incorporation, to confirm signing authority. 
        Verify the Seller names in the Land Title document; refrain 
        from simply copying them from the listing as discrepancies in names may 
        exist.</p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>Municipal Address: </strong>Enter the full municipal address of the property.  
        Verify address details in the Land Title document. Keep in mind that the 
        title does not always match the municipal address. For example, in the case
        where the property is used as an income property. Refrain from simply 
        copying them from the listing as discrepancies may exist.</p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Legal Description:</strong> Verify the legal 
        description in the Land Title document and insert the details here, 
        do not copy from listing.</p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,

        data: `<p><strong>Unattached Goods:</strong> These are items that are to be included
        in the purchase price and typically involve items not fixed to the property. 
        Chattels are movable items such as: appliances, garage door remotes, mirrors
        not fixed to the walls...etc. It is important to be as detailed as possible
        when describing the chattels to be included. Some items such as fixed tv mounts
        have been greatly debated as to whether they need to be included in the 
        unattached goods section. 
        As a rule of thumb, "if in doubt, include it" so that it is clear to all 
        parties.</p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Attached Goods Excluded:</strong> These are items that are
        attached to the home but the Seller wishes to exclude them from the sale. 
        One reason may be that the item listed has sentimental value like a lighting 
        fixture. Precision is key when itemizing excluded fixtures, for instance, 
        specifying "bedroom light fixture."</p>`,
      },
      {
        x: `1.5%`,
        y: `47.5%`,
        data: `<p><strong>Purchase Price:</strong> This is the price the Buyer is 
        offering for the property. The price almost always includes GST. If you 
        are unsure or feel that GST might be applicable, you should always refer the 
        client to an accountant or lawyer by way of an accountant/lawyer review 
        clause in the contract. If GST is applicable, be sure to include a term 
        in the contract that addresses that all parties are aware GST may be 
        applicable and who will be responsible for paying it.  
        </p>`,
      },
      {
        x: `1.5%`,
        y: `52%`,
        data: `<p><strong>Completion Date:</strong> This is the proposed date of 
        closing (the date your clients would like to take ownership of the property). 
        Ensure that the date placed here is not a weekend or holiday. <br/>As per 2.4,
        the Seller also represents & warrants that the property will be in the same 
        condition as when this contract is accepted as well as all the included 
        attached/unattached goods.</p>`,
      },
      {
        x: `1.5%`,
        y: `59%`,
        data: `<p><strong>Section 3:</strong> Understanding all the General 
        Terms included in this contract is essential. This section establishes a 
        standard set of legal and practical terms that guide how the Buyer and Seller 
        must behave and what rules govern the real estate transaction. If your client has 
        any questions, you should be prepared to explain each element clearly and 
        professionally. </p>`,
      },

      {
        x: `19%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1002,
    form: `ResidentialPurchaseContract`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `13.5%`,
        data: `<p>This section outlines which Brokerage is responsible for 
        delivering the contract and related documents to the lawyers 
        involved in the transaction. While this is usually done by the 
        Seller's Brokerage, either the Buyer's or Seller's Brokerage may 
        take on this responsibility. Be sure to specify which one applies.</p>`,
      },

      {
        x: `1.5%`,
        y: `19%`,
        data: `<p><strong>Deposits:</strong> This section explains the terms 
        related to how the deposit will be delivered. It’s recommended to 
        check with the listing agent or lawyer in advance to confirm what 
        payment methods are accepted by their Brokerage or office before 
        filling out this section. <br/>
        <strong>4.2: </strong>Insert who will hold the deposit (in trust). Typically 
        the listing Brokerage holds the deposit but it can be either a Brokerage or 
        lawyer if the parties agree otherwise.<br/>
        <strong>4.3: </strong>Enter the amount of deposit that will be provided, 
        method of payment, and when the deposit is due. Typically this may be via e-transfer or bank 
        draft but it is important to discuss methods of payment that are acceptable 
        with the party that will be holding the deposit.<br/>
        <strong>4.4: </strong>If an additional deposit is to be made as part of this 
        contract, complete this section similar to section 4.3. If no additional 
        deposit is to be made, this can be left blank.<br/>
        <strong>4.5-4.9: </strong>Understanding these additional Deposit 
        Terms included in this contract is essential. If your client has 
        any questions, you should be prepared to explain each element 
        clearly and professionally.</p>`,
      },
      {
        x: `1.5%`,
        y: `56%`,
        data: `<p><strong>Land Title: </strong>Understanding these additional 
        Terms relating to Land Title is essential. Simply put, When the 
        property is sold, the ownership title must be clear of any financial 
        claims or legal issues, except for a few specific types that are 
        considered normal or agreed to. <br/>
        The Seller promises to give the Buyer clear ownership of the 
        property. That means no mortgages, unpaid taxes, or legal claims that 
        could affect the Buyer's ownership—unless listed below.
        <ol>
        <li>These are rights or restrictions that apply automatically under 
        Yukon law, even if they're not written on the title. Example: a legal 
        right of access for emergency services.</li>
        <li>These are common, non-money-related things already registered on 
        the property that are normal for this type of property, and the Buyer 
        is expected to accept. Example: easements, rights-of-way, restrictive 
        covenants..etc.</li>
        <li>Anything the Buyer has agreed to accept in the contract.</li>
        </ol>
        <br/>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Representations and Warranties: </strong>In this 
        section, the Seller 
        makes several important promises (representations and warranties) to 
        the Buyer, which are like guarantees about the property. As per 6.2, on 
        the top of the next page, it is important to note that these representations 
        and warranties go beyond the closing of the transaction, with restrictions. <br/>
        <strong>Example: </strong>Let's 
        say after the sale, the Seller forgot to fix something they 
        promised (e.g., a repair). The Buyer can still take legal action 
        to make sure it's fixed, but only if they start that action within 
        the time allowed by law (usually a few years).
        </p>`,
      },
      {
        x: `19%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1003,
    form: `ResidentialPurchaseContract`,
    page: `3`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Conditions (7.1):</strong> This section outlines the 
        conditions that are included as part of the contract. The Buyer and 
        Seller promise to act fairly, do their part to meet their conditions, 
        and cover any costs that come with meeting those conditions. </p>`,
      },
      {
        x: `1.5%`,
        y: `23%`,
        data: `<p><strong>Conditions (7.2):</strong> In this section, fill in 
        the details for any conditions the Buyer wishes to include in the 
        contract. As professional REALTORS®, it's important to clearly 
        explain the potential risks and benefits of each condition to 
        help your client make an informed decision about whether or not 
        to include them. “Time is of the essence” when it comes to all elements 
        of the contract, especially conditions. Make sure that contracts and 
        related deal documents are signed within their designated time 
        frames to best protect your clients. Any 
        pre-printed conditions in this section that are left incomplete 
        will not form part of the contract.
        <br/>In accordance 7.4 (below), 
        failure to waive or satisfy the conditions within the specified 
        timeframe will result in the contract being terminated, provided the 
        correct notice is delivered.</p>`,
      },
      {
        x: `1.5%`,
        y: `52%`,
        data: `<p><strong>Additional Buyer's Conditions:</strong> Insert any 
        additional Buyer's conditions in this section that will form part of 
        the contract. If the condition is not in the Clause Booklet or an eXp 
        approved condition, have your clients lawyer draw up the custom 
        condition to best protect your client(s). At the bottom, insert a date when these conditions are due 
        to be satisfied. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Additional Seller's Conditions:</strong> The Seller 
        will insert any conditions in this section that they will to form part 
        of the contract. If you represent the Seller and the condition is not 
        in the Clause Booklet or an eXp approved condition, have your clients 
        lawyer draw up the custom condition to best protect your client(s). At 
        the bottom, insert a date when these conditions are due to be satisfied. 
        </p>`,
      },
      {
        x: `19%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1004,
    form: `ResidentialPurchaseContract`,
    page: `4`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Attachments and Additional Terms:</strong> Select 
        the checkboxes for any documents that are attached to this contract 
        and considered part of the contract. If none appy, this can be left 
        blank.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Other Terms:</strong> Enter any additional terms 
        that will be included as part of the contract. If the term is not in 
        the Clause Booklet or an eXp approved term, have your clients lawyer 
        draw up the custom term to best protect your client(s). It is important 
        to note that terms typically cannot stop a contract from proceeding. Their 
        presence is more to provide a guide for the parties to follow.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Closing Process:</strong> Understanding the Closing 
        Process and being able to explain to your client clearly and 
        professionally is paramount to doing your part in ensuring a smooth 
        closing. Make sure you understand this section of the contract so you can 
        confidently explain the process to your client.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `82%`,
        data: `<p><strong>Insurance:</strong> In short, If the property gets damaged 
        before the Buyer has paid in full, the Seller is responsible for it, 
        and any insurance money will be held for both the Seller and Buyer, 
        depending on what they're owed. </p>`,
      },
      {
        x: `19%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1005,
    form: `ResidentialPurchaseContract`,
    page: `5`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-5.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Remedies:</strong> If one party fails to complete the 
        contract, it's important to understand the potential consequences 
        of that action. Have your client fully understand the seriousness of 
        entering into a legally binding contract.  If one party does not 
        complete the deal, advise your client to consult their lawyer to 
        ensure the situation is handled appropriately.</p>`,
      },
      {
        x: `1.5%`,
        y: `20%`,
        data: `<p><strong>Notices and Documents:</strong> Ensure you are familiar 
        with the process of serving notices and documents. “Time is of the 
        essence” when it comes to all elements of the contract, especially 
        when serving time sensitive documents. Make sure that notices and 
        documents are signed and delivered 
        within their designated time frames to best protect your clients.</p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Authorization:</strong> Complete this section by 
        entering the names of both the Seller's and Buyer's Brokerages, 
        along with the agents involved in the transaction. If one party does 
        not have a REALTOR® or Brokerage, this section should either be left 
        blank or read "Self Represented" in the section that applies. 
        Additionally, see section 13.2 below when dealing with a situation in 
        which one party is not using a REALTOR® or Brokerage. </p>`,
      },
      {
        x: `1.5%`,
        y: `58%`,
        data: `<p><strong>Authorization of Other Party:</strong> If the Seller 
        or Buyer does not have a Brokerage (meaning the are not using a 
         REALTOR® or Brokerage), they must name someone else to 
        receive important documents and notices on their behalf. According to 
        section 13.3, if this information changes, the other party must be 
        notified in writing of the updated details as soon as the change occurs.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Confirmation of Contract Terms:</strong>  In short, this section states 
        that this contract is the complete and final Agreement. If it's not 
        written in here, it's 
        not part of the deal...even if someone said it before signing. At the 
        bottom of this section, have your clients initial on the line that 
        applies. Their initials signify that they understand the statements made in 
        this section. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `82%`,
        data: `<p><strong>Legal Obligations Begin:</strong> This section states 
        that the contract is official once it's delivered. After that, 
        the Buyer and Seller---and anyone who legally steps into their 
        place must follow what the contract says.
        </p>`,
      },
      {
        x: `19%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1006,
    form: `ResidentialPurchaseContract`,
    page: `6`,
    imageURL: "../../images/Yukon/forms/ResidentialPurchaseContract/RPS-6.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9.5%`,
        data: `<p><strong>Offer:</strong> In this section, the Buyer offers to buy the property with the 
        specified terms of this contract. 
        The offer can only be accepted in writing before the specified date and 
        time, which will be filled in here. If there are multiple Buyers, 
        complete the information as shown in the example provided.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `28%`,
        data: `<p><strong>Acceptance:</strong> If the Seller chooses to accept based on the terms of the 
        contract, complete this section. It is imperative that the time of 
        acceptance occurs before the time set in Section 16. If there are 
        multiple Sellers, complete the information as shown in the example 
        provided.</p>`,
      },
      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Rejection:</strong> This section should be 
        completed if the Seller does not agree to the offer or counteroffer 
        made by the Buyer and does not intend to make a counteroffer.</p>`,
      },
      {
        x: `1.5%`,
        y: `57%`,
        data: `<p><strong>Conveyancing Information:</strong> If the information 
        is available, please complete this section with your client's 
        details as well as their lawyer's. If it is not available at the 
        time of the offer, it can be provided to the other party at a 
        later date.</p>`,
      },
      {
        x: `19%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1011,
    form: `RPS-condo`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-1.png",
    description: `<p>The Residential Condo Purchase Contract stands as 
    the primary document employed in acquiring residential condo resale properties. 
    As you complete this contract, it is imperative to cross-reference all property 
    details with secondary sources. While the listing 
    agent bears the responsibility of ensuring listing accuracy, it remains crucial 
    to undertake thorough due diligence for your client, refraining from solely 
    depending on the listing information.
     </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyers & Sellers:</strong> Ensure that you input the complete legal names of both Buyers and 
        Sellers. Take the extra step of cross-referencing your clients' IDs to 
        guarantee accuracy. If the client is a corporation, be sure to obtain 
        documents, such as the Articles of Incorporation, to confirm signing authority. 
        Verify the Seller names in the Land Title document; refrain 
        from simply copying them from the listing as discrepancies in names may 
        exist.</p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>Municipal Address: </strong>Enter the full municipal address of the property.  
        Verify address details in the Land Title document. Keep in mind that the 
        title does not always match the municipal address. For example, in the case
        where the property is used as an income property. Refrain 
        from simply copying them from the listing as discrepancies may 
        exist.</p>`,
      },
      {
        x: `1.5%`,
        y: `29.5%`,
        data: `<p><strong>Project Name:</strong> Insert the name of the 
        project/building name here. In some cases, such as pre-construction, the 
        name may not exist, in which case you can leave this blank.</p>`,
      },
      {
        x: `1.5%`,
        y: `34%`,
        data: `<p><strong>Legal Description:</strong> Verify the legal 
        description in the Land Title document and insert the details here, 
        do not copy from listing. All fields in this section may not apply. Note 
        that the unit number for this section is the "legal unit number" and does 
        not necessarily match with the municipal unit number. 
        Complete the necessary fields for the specific property. <br/>
        <strong>Parking/Storage:</strong> Be sure to include any legal parking 
        and storage details if they apply to the deal. If these are missing 
        from the legal description in the contract, they won't be part of the 
        sale and the Seller may retain the right to sell them separately.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `43%`,
        data: `<p><strong>Unattached Goods:</strong> These are items that are to be included
        in the purchase price and typically involve items not fixed to the property. 
        Chattels are movable items such as: appliances, garage door remotes, mirrors
        not fixed to the walls...etc. It is important to be as detailed as possible
        when describing the chattels to be included. Some items such as fixed tv mounts
        have been greatly debated as to whether they need to be included in the 
        unattached goods section. 
        As a rule of thumb, "if in doubt, include it" so that it is clear to all 
        parties.</p>`,
      },
      {
        x: `1.5%`,
        y: `50%`,
        data: `<p><strong>Attached Goods Excluded:</strong> These are items that are
        attached to the home but the Seller wishes to exclude them from the sale. 
        One reason may be that the item listed has sentimental value like a lighting 
        fixture. Precision is key when itemizing excluded fixtures, for instance, 
        specifying "bedroom light fixture."</p>`,
      },
      {
        x: `1.5%`,
        y: `55%`,
        data: `<p><strong>Purchase Price:</strong> This is the price the Buyer is 
        offering for the property. The price almost always includes GST. If you 
        are unsure or feel that GST might be applicable, you should always refer the 
        client to an accountant or lawyer by way of an accountant/lawyer review 
        clause in the contract. If GST is applicable, be sure to include a term 
        in the contract that addresses that all parties are aware GST may be 
        applicable and who will be responsible for paying it.  </p>`,
      },
      {
        x: `1.5%`,
        y: `60%`,
        data: `<p><strong>Completion Date:</strong> This is the proposed date of 
        closing (the date your clients would like to take ownership of the property). 
        Ensure that the date placed here is not a weekend or holiday. <br/>As per 2.4,
        the Seller also represents & warrants that the property will be in the same 
        condition as when this contract is accepted as well as all the included 
        attached/unattached goods.</p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Section 3:</strong> Understanding all the General 
        Terms included in this contract is essential. This section establishes a 
        standard set of legal and practical terms that guide how the Buyer and Seller 
        must behave and what rules govern the real estate transaction. If your client has 
        any questions, you should be prepared to explain each element clearly and 
        professionally. </p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1012,
    form: `RPS-condo`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `39%`,
        data: `<p><strong>Delivery of Contract/Documents:</strong> This section outlines which Brokerage is responsible for 
        delivering the contract and related documents to the lawyers 
        involved in the transaction. While this is usually done by the 
        Seller's Brokerage, either the Buyer's or Seller's Brokerage may 
        take on this responsibility. Be sure to specify which one applies.</p>`,
      },

      {
        x: `1.5%`,
        y: `44%`,
        data: `<p><strong>Deposits:</strong> This section explains the terms 
        related to how the deposit will be delivered. It’s recommended to 
        check with the listing agent or lawyer in advance to confirm what 
        payment methods are accepted by their Brokerage or office before 
        filling out this section. <br/>
        <strong>4.2: </strong>Insert who will hold the deposit (in trust). Typically 
        the listing Brokerage holds the deposit but it can be either a Brokerage or 
        lawyer if the parties agree otherwise.<br/>
        <strong>4.3: </strong>Enter the amount of deposit that will be provided, 
        method of payment, and when the deposit is due. Typically this may be via e-transfer or bank 
        draft but it is important to discuss methods of payment that are acceptable 
        with the party that will be holding the deposit.<br/>
        <strong>4.4: </strong>If an additional deposit is to be made as part of this 
        contract, complete this section similar to section 4.3. If no additional 
        deposit is to be made, this can be left blank.<br/>
        <strong>4.5-4.9: </strong>Understanding these additional Deposit 
        Terms included in this contract is essential. If your client has 
        any questions, you should be prepared to explain each element 
        clearly and professionally.</p>`,
      },
      {
        x: `1.5%`,
        y: `80%`,
        data: `<p><strong>Land Title: </strong>Understanding these additional 
        Terms relating to Land Title are essential. Simply put, When the 
        property is sold, the ownership title must be clear of any financial 
        claims or legal issues, except for a few specific types that are 
        considered normal or agreed to. <br/>
        The Seller promises to give the Buyer clear ownership of the 
        property. That means no mortgages, unpaid taxes, or legal claims that 
        could affect the Buyer's ownership—unless listed below.
        <ol>
        <li>These are rights or restrictions that apply automatically under 
        Yukon law, even if they're not written on the title. Example: a legal 
        right of access for emergency services.</li>
        <li>These are common, non-money-related things already registered on 
        the property that are normal for this type of property, and the Buyer 
        is expected to accept. Example: easements, rights-of-way, restrictive 
        covenants..etc.</li>
        <li>Anything the Buyer has agreed to accept in the contract.</li>
        </ol>
        <br/>
        </p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1013,
    form: `RPS-condo`,
    page: `3`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Representations and Warranties: </strong>In this 
        section, the Seller 
        makes several important promises (representations and warranties) to 
        the Buyer, which are like guarantees about the property. As per 6.2, it is 
        important to note that these representations 
        and warranties go beyond the closing of the transaction, with restrictions. <br/>
        <strong>Example: </strong>Let's 
        say after the sale, the Seller forgot to fix something they 
        promised (e.g., a repair). The Buyer can still take legal action 
        to make sure it's fixed, but only if they start that action within 
        the time allowed by law (usually a few years).
        </p>`,
      },
      {
        x: `1.5%`,
        y: `35%`,
        data: `<p><strong>Conditions (7.1):</strong> This section outlines the 
        conditions that are included as part of the contract. The Buyer and 
        Seller promise to act fairly, do their part to meet their conditions, 
        and cover any costs that come with meeting those conditions.</p>`,
      },
      {
        x: `1.5%`,
        y: `48%`,
        data: `<p><strong>Conditions (7.2):</strong> In this section, fill in 
        the details for any conditions the Buyer wishes to include in the 
        contract. As professional REALTORS®, it's important to clearly 
        explain the potential risks and benefits of each condition to 
        help your client make an informed decision about whether or not 
        to include them. “Time is of the essence” when it comes to all elements 
        of the contract, especially conditions. Make sure that contracts and 
        related deal documents are signed within their designated time 
        frames to best protect your clients. Any 
        pre-printed conditions in this section that are left incomplete 
        will not form part of the contract.
        <br/>In accordance 7.4 (below), 
        failure to waive or satisfy the conditions within the specified 
        timeframe will result in the contract being terminated, provided the 
        correct notice is delivered.</p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1014,
    form: `RPS-condo`,
    page: `4`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Conditions Continued...:</strong> Fill in 
        the details for any conditions the Buyer wishes to include in the 
        contract. As professional REALTORS®, it's important to clearly 
        explain the potential risks and benefits of each condition to 
        help your client make an informed decision about whether or not 
        to include them. “Time is of the essence” when it comes to all elements 
        of the contract, especially conditions. Make sure that contracts and 
        related deal documents are signed within their designated time 
        frames to best protect your clients. 
        <br/>In accordance 7.4 (below), 
        failure to waive or satisfy the conditions within the specified 
        timeframe will result in the contract being terminated, provided the 
        correct notice is delivered.</p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Additional Buyer's Conditions:</strong> Insert any 
        additional Buyer's conditions in this section that will form part of 
        the contract. If the condition is not in the Clause Booklet or an eXp 
        approved condition, have your clients lawyer draw up the custom 
        condition to best protect your client(s). At the bottom, insert a date when these conditions are due 
        to be satisfied. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `75%`,
        data: `<p><strong>Additional Seller's Conditions:</strong> The Seller 
        will insert any conditions in this section that they will to form part 
        of the contract. If you represent the Seller and the condition is not 
        in the Clause Booklet or an eXp approved condition, have your clients 
        lawyer draw up the custom condition to best protect your client(s). At 
        the bottom, insert a date when these conditions are due to be satisfied. 
        </p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1015,
    form: `RPS-condo`,
    page: `5`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-5.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Attachments and Additional Terms:</strong> Select 
        the checkboxes for any documents that are attached to this contract 
        and considered part of the contract. If none appy, this can be left 
        blank.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `20%`,
        data: `<p><strong>Condo Fees:</strong> Insert the total monthly condo fees 
        for the property as well as for any non-titled, assigned or leased areas.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `28%`,
        data: `<p><strong>Other Terms:</strong> Enter any additional terms 
        that will be included as part of the contract. If the term is not in 
        the Clause Booklet or an eXp approved term, have your clients lawyer 
        draw up the custom term to best protect your client(s). It is important 
        to note that terms typically cannot stop a contract from proceeding. Their 
        presence is more to provide a guide for the parties to follow. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `37%`,
        data: `<p><strong>Closing Process:</strong> Understanding the Closing 
        Process and being able to explain to your client clearly and 
        professionally is paramount to doing your part in ensuring a smooth 
        closing. Make sure you understand this section of the contract so you can 
        confidently explain the process to your client.
        </p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1016,
    form: `RPS-condo`,
    page: `6`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-6.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `31%`,
        data: `<p><strong>Insurance:</strong> In short, If the property gets damaged 
        before the Buyer has paid in full, the Seller is responsible for it, 
        and any insurance money will be held for both the Seller and Buyer, 
        depending on what they're owed. </p>`,
      },
      {
        x: `1.5%`,
        y: `35%`,
        data: `<p><strong>Remedies:</strong> If one party fails to complete the 
        contract, it's important to understand the potential consequences 
        of that action. Have your client fully understand the seriousness of 
        entering into a legally binding contract.  If one party does not 
        complete the deal, advise your client to consult their lawyer to 
        ensure the situation is handled appropriately.</p>`,
      },
      {
        x: `1.5%`,
        y: `46%`,
        data: `<p><strong>Notices and Documents:</strong> Ensure you are familiar 
        with the process of serving notices and documents. “Time is of the 
        essence” when it comes to all elements of the contract, especially 
        when serving time sensitive documents. Make sure that notices and 
        documents are signed and delivered 
        within their designated time frames to best protect your clients.</p>`,
      },
      {
        x: `1.5%`,
        y: `58%`,
        data: `<p><strong>Authorization:</strong> Complete this section by entering the names of both the 
        Seller's and Buyer's Brokerages, along with the agents involved in the 
        transaction. If one party does 
        not have a REALTOR® or Brokerage, this section should either be left 
        blank or read "Self Represented" in the section that applies. 
        Additionally, see section 13.2 below when dealing with a situation in 
        which one party is not using a REALTOR® or Brokerage.</p>`,
      },
      {
        x: `1.5%`,
        y: `84%`,
        data: `<p><strong>Authorization of Other Party:</strong> If the Seller 
        or Buyer does not have a Brokerage (meaning the are not using a 
         REALTOR® or Brokerage), they must name someone else to 
        receive important documents and notices on their behalf. According to 
        section 13.3, if this information changes, the other party must be 
        notified in writing of the updated details as soon as the change occurs.
        </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1017,
    form: `RPS-condo`,
    page: `7`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-7.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Confirmation of Contract Terms:</strong>  In short, this section states 
        that this contract is the complete and final Agreement. If it's not 
        written in here, it's 
        not part of the deal...even if someone said it before signing. At the 
        bottom of this section, have your clients initial on the line that 
        applies. Their initials signify that they understand the statements made in 
        this section. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Legal Obligations Begin:</strong> This section states 
        that the contract is official once it's delivered. After that, 
        the Buyer and Seller---and anyone who legally steps into their 
        place must follow what the contract says.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `37%`,
        data: `<p><strong>Offer:</strong> In this section, the Buyer offers to buy the property with the 
        specified terms of this contract. 
        The offer can only be accepted in writing before the specified date and 
        time, which will be filled in here. If there are multiple Buyers, 
        complete the information as shown in the example provided.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `55%`,
        data: `<p><strong>Acceptance:</strong> If the Seller chooses to accept based on the terms of the 
        contract, complete this section. It is imperative that the time of 
        acceptance occurs before the time set in Section 16. If there are 
        multiple Sellers, complete the information as shown in the example 
        provided.</p>`,
      },
      {
        x: `1.5%`,
        y: `82%`,
        data: `<p><strong>Rejection:</strong> This section should be 
        completed if the Seller does not agree to the offer or counteroffer 
        made by the Buyer and does not intend to make a counteroffer.</p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1018,
    form: `RPS-condo`,
    page: `8`,
    imageURL: "../../images/Yukon/forms/RPS-condo/RPS-condo-8.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `10%`,
        data: `<p><strong>Conveyancing Information:</strong> If the information 
        is available, please complete this section with your client's 
        details as well as their lawyer's. If it is not available at the 
        time of the offer, it can be provided to the other party at a 
        later date.</p>`,
      },
    ],
  },
  {
    id: 1021,
    form: `RPS-country`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-1.png",
    description: `<p>The Country Residential Purchase Contract stands as 
    the primary document employed in acquiring rural properties. 
    As you complete this contract, it is imperative to cross-reference all property 
    details with secondary sources. While the listing 
    agent bears the responsibility of ensuring listing accuracy, it remains crucial 
    to undertake thorough due diligence for your client, refraining from solely 
    depending on the listing information.
     </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyers & Sellers:</strong> Ensure that you input the complete legal names of both Buyers and 
        Sellers. Take the extra step of cross-referencing your clients' IDs to 
        guarantee accuracy. If the client is a corporation, be sure to obtain 
        documents, such as the Articles of Incorporation, to confirm signing authority. 
        Verify the Seller names in the Land Title document; refrain 
        from simply copying them from the listing as discrepancies in names may 
        exist.</p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Legal Description:</strong> Verify the legal 
        description in the Land Title document and insert the details here, 
        do not copy from listing. All fields in this section may not apply. 
        Complete the necessary fields for the specific property. <br/>
      
        </p>`,
      },
      {
        x: `1.5%`,
        y: `36%`,
        data: `<p><strong>Municipal Address: </strong>Enter the full municipal address of the property.  
        Verify address details in the Land Title document. Keep in mind that the 
        title does not always match the municipal address. For example, in the case
        where the property is used as an income property. Refrain 
        from simply copying them from the listing as discrepancies may 
        exist.</p>`,
      },

      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Unattached Goods:</strong> These are items that are to be included
        in the purchase price and typically involve items not fixed to the property. 
        Chattels are movable items such as: appliances, garage door remotes, mirrors
        not fixed to the walls...etc. It is important to be as detailed as possible
        when describing the chattels to be included. Some items such as fixed tv mounts
        have been greatly debated as to whether they need to be included in the 
        unattached goods section. 
        As a rule of thumb, "if in doubt, include it" so that it is clear to all 
        parties.</p>`,
      },
      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>Attached Goods Excluded:</strong> These are items that are
        attached to the home but the Seller wishes to exclude them from the sale. 
        One reason may be that the item listed has sentimental value like a lighting 
        fixture. Precision is key when itemizing excluded fixtures, for instance, 
        specifying "bedroom light fixture."</p>`,
      },
      {
        x: `1.5%`,
        y: `58%`,
        data: `<p><strong>Purchase Price:</strong> This is the price the Buyer is 
        offering for the property. The price almost always includes GST. If you 
        are unsure or feel that GST might be applicable, you should always refer the 
        client to an accountant or lawyer by way of an accountant/lawyer review 
        clause in the contract. If GST is applicable, be sure to include a term 
        in the contract that addresses that all parties are aware GST may be 
        applicable and who will be responsible for paying it.  </p>`,
      },
      {
        x: `1.5%`,
        y: `61%`,
        data: `<p><strong>Completion Date:</strong> This is the proposed date of 
        closing (the date your clients would like to take ownership of the property). 
        Ensure that the date placed here is not a weekend or holiday. <br/>As per 2.4,
        the Seller also represents & warrants that the property will be in the same 
        condition as when this contract is accepted as well as all the included 
        attached/unattached goods.</p>`,
      },
      {
        x: `1.5%`,
        y: `68%`,
        data: `<p><strong>Section 3:</strong> Understanding all the General 
        Terms included in this contract is essential. This section establishes a 
        standard set of legal and practical terms that guide how the Buyer and Seller 
        must behave and what rules govern the real estate transaction. If your client has 
        any questions, you should be prepared to explain each element clearly and 
        professionally. </p>`,
      },

      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1022,
    form: `RPS-country`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Delivery of Contract/Documents:</strong> This section outlines which Brokerage is responsible for 
        delivering the contract and related documents to the lawyers 
        involved in the transaction. While this is usually done by the 
        Seller's Brokerage, either the Buyer's or Seller's Brokerage may 
        take on this responsibility. Be sure to specify which one applies.</p>`,
      },

      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Deposits:</strong> This section explains the terms 
        related to how the deposit will be delivered. It’s recommended to 
        check with the listing agent or lawyer in advance to confirm what 
        payment methods are accepted by their Brokerage or office before 
        filling out this section. <br/>
        <strong>4.2: </strong>Insert who will hold the deposit (in trust). Typically 
        the listing Brokerage holds the deposit but it can be either a Brokerage or 
        lawyer if the parties agree otherwise.<br/>
        <strong>4.3: </strong>Enter the amount of deposit that will be provided, 
        method of payment, and when the deposit is due. Typically this may be via e-transfer or bank 
        draft but it is important to discuss methods of payment that are acceptable 
        with the party that will be holding the deposit.<br/>
        <strong>4.4: </strong>If an additional deposit is to be made as part of this 
        contract, complete this section similar to section 4.3. If no additional 
        deposit is to be made, this can be left blank.<br/>
        <strong>4.5-4.9: </strong>Understanding these additional Deposit 
        Terms included in this contract are essential. If your client has 
        any questions, you should be prepared to explain each element 
        clearly and professionally.</p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>Land Title: </strong>Understanding these additional 
        Terms relating to Land Title are essential. Simply put, When the 
        property is sold, the ownership title must be clear of any financial 
        claims or legal issues, except for a few specific types that are 
        considered normal or agreed to. <br/>
        The Seller promises to give the Buyer clear ownership of the 
        property. That means no mortgages, unpaid taxes, or legal claims that 
        could affect the Buyer's ownership—unless listed below.
        <ol>
        <li>These are rights or restrictions that apply automatically under 
        Yukon law, even if they're not written on the title. Example: a legal 
        right of access for emergency services.</li>
        <li>These are common, non-money-related things already registered on 
        the property that are normal for this type of property, and the Buyer 
        is expected to accept. Example: easements, rights-of-way, restrictive 
        covenants..etc.</li>
        <li>Anything the Buyer has agreed to accept in the contract.</li>
        </ol>
        <br/>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `71%`,
        data: `<p><strong>Representations and Warranties: </strong>In this 
        section, the Seller 
        makes several important promises (representations and warranties) to 
        the Buyer, which are like guarantees about the property. As per 6.2, on 
        the top of the next page, it is important to note that these representations 
        and warranties go beyond the closing of the transaction, with restrictions. <br/>
        <strong>Example: </strong>Let's 
        say after the sale, the Seller forgot to fix something they 
        promised (e.g., a repair). The Buyer can still take legal action 
        to make sure it's fixed, but only if they start that action within 
        the time allowed by law (usually a few years).
        </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1023,
    form: `RPS-country`,
    page: `3`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Conditions (7.1):</strong> This section outlines the 
        conditions that are included as part of the contract. The Buyer and 
        Seller promise to act fairly, do their part to meet their conditions, 
        and cover any costs that come with meeting those conditions.</p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>Conditions (7.2):</strong> In this section, fill in 
        the details for any conditions the Buyer wishes to include in the 
        contract. As professional REALTORS®, it's important to clearly 
        explain the potential risks and benefits of each condition to 
        help your client make an informed decision about whether or not 
        to include them. “Time is of the essence” when it comes to all elements 
        of the contract, especially conditions. Make sure that contracts and 
        related deal documents are signed within their designated time 
        frames to best protect your clients. Any 
        pre-printed conditions in this section that are left incomplete 
        will not form part of the contract.
        <br/>In accordance 7.4 (below), 
        failure to waive or satisfy the conditions within the specified 
        timeframe will result in the contract being terminated, provided the 
        correct notice is delivered.</p>`,
      },
      {
        x: `1.5%`,
        y: `84%`,
        data: `<p><strong>Additional Buyer's Conditions:</strong> Insert any 
        additional Buyer's conditions in this section that will form part of 
        the contract. If the condition is not in the Clause Booklet or an eXp 
        approved condition, have your clients lawyer draw up the custom 
        condition to best protect your client(s). At the bottom, insert a date when these conditions are due 
        to be satisfied. 
        </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1024,
    form: `RPS-country`,
    page: `4`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-4.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `10%`,
        data: `<p><strong>Additional Seller's Conditions:</strong> The Seller 
        will insert any conditions in this section that they will to form part 
        of the contract. If you represent the Seller and the condition is not 
        in the Clause Booklet or an eXp approved condition, have your clients 
        lawyer draw up the custom condition to best protect your client(s). At 
        the bottom, insert a date when these conditions are due to be satisfied. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Attachments and Additional Terms:</strong> Select 
        the checkboxes for any documents that are attached to this contract 
        and considered part of the contract. If none appy, this can be left 
        blank.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Condominium Unit Contribution and Fees:</strong> If 
        the property is a condominium unit, this section will be completed. 
        If the property is not a condominium unit, this section can be left 
        blank.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `44%`,
        data: `<p><strong>Other Terms:</strong> Enter any additional terms 
        that will be included as part of the contract. If the term is not in 
        the Clause Booklet or an eXp approved term, have your clients lawyer 
        draw up the custom term to best protect your client(s). It is important 
        to note that terms typically cannot stop a contract from proceeding. Their 
        presence is more to provide a guide for the parties to follow.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `52%`,
        data: `<p><strong>Closing Process:</strong> Understanding the Closing 
        Process and being able to explain to your client clearly and 
        professionally is paramount to doing your part in ensuring a smooth 
        closing. Make sure you understand this section of the contract so you can 
        confidently explain the process to your client.
        </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1025,
    form: `RPS-country`,
    page: `5`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-5.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `39%`,
        data: `<p><strong>Insurance:</strong> In short, If the property gets damaged 
        before the Buyer has paid in full, the Seller is responsible for it, 
        and any insurance money will be held for both the Seller and Buyer, 
        depending on what they're owed. </p>`,
      },
      {
        x: `1.5%`,
        y: `43%`,
        data: `<p><strong>Remedies:</strong> If one party fails to complete the 
        contract, it's important to understand the potential consequences 
        of that action. Have your client fully understand the seriousness of 
        entering into a legally binding contract.  If one party does not 
        complete the deal, advise your client to consult their lawyer to 
        ensure the situation is handled appropriately.</p>`,
      },
      {
        x: `1.5%`,
        y: `53%`,
        data: `<p><strong>Notices and Documents:</strong> Ensure you are familiar 
        with the process of serving notices and documents. “Time is of the 
        essence” when it comes to all elements of the contract, especially 
        when serving time sensitive documents. Make sure that notices and 
        documents are signed and delivered 
        within their designated time frames to best protect your clients.</p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Authorization:</strong> Complete this section by 
        entering the names of both the Seller's and Buyer's Brokerages, 
        along with the agents involved in the transaction. If one party does 
        not have a REALTOR® or Brokerage, this section should either be left 
        blank or read "Self Represented" in the section that applies. 
        Additionally, see section 13.2 below when dealing with a situation in 
        which one party is not using a REALTOR® or Brokerage. </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1026,
    form: `RPS-country`,
    page: `6`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-6.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Authorization of Other Party:</strong> If the Seller 
        or Buyer does not have a Brokerage (meaning the are not using a 
         REALTOR® or Brokerage), they must name someone else to 
        receive important documents and notices on their behalf. According to 
        section 13.3, if this information changes, the other party must be 
        notified in writing of the updated details as soon as the change occurs.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Confirmation of Contract Terms:</strong>  In short, this section states 
        that this contract is the complete and final Agreement. If it's not 
        written in here, it's 
        not part of the deal...even if someone said it before signing. At the 
        bottom of this section, have your clients initial on the line that 
        applies. Their initials signify that they understand the statements made in 
        this section. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `34%`,
        data: `<p><strong>Legal Obligations Begin:</strong> This section states 
        that the contract is official once it's delivered. After that, 
        the Buyer and Seller---and anyone who legally steps into their 
        place must follow what the contract says.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `41%`,
        data: `<p><strong>Offer:</strong> In this section, the Buyer offers to buy the property with the 
        specified terms of this contract. 
        The offer can only be accepted in writing before the specified date and 
        time, which will be filled in here. If there are multiple Buyers, 
        complete the information as shown in the example provided.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `61%`,
        data: `<p><strong>Acceptance:</strong> If the Seller chooses to accept based on the terms of the 
        contract, complete this section. It is imperative that the time of 
        acceptance occurs before the time set in Section 16. If there are 
        multiple Sellers, complete the information as shown in the example 
        provided.</p>`,
      },
      {
        x: `1.5%`,
        y: `82%`,
        data: `<p><strong>Rejection:</strong> This section should be 
        completed if the Seller does not agree to the offer or counteroffer 
        made by the Buyer and does not intend to make a counteroffer.</p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1027,
    form: `RPS-country`,
    page: `7`,
    imageURL: "../../images/Yukon/forms/RPS-country/RPS-country-7.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Conveyancing Information:</strong> If the information 
        is available, please complete this section with your client's 
        details as well as their lawyer's. If it is not available at the 
        time of the offer, it can be provided to the other party at a 
        later date.</p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },

  {
    id: 1031,
    form: `country-schedule`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/RPS-country/country-schedule-1.png",
    description: `<p>The purpose of this document is to: Provide extra details 
    specific to Rural/Country residential properties that aren't covered in the 
    standard contracts. Disclose important information about the property's 
    utilities and systems, such as water supply, sewage, septic systems, heating, 
    and access roads. Clarify boundaries and land use, including fences, outbuildings, 
    zoning, and agricultural or livestock use. This form helps the Buyer understand 
    exactly what they're purchasing. This reduces the risk of disputes by making
    sure both parties are clear on the condition and features of the property.
     </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number here 
        must match the Contract Number on the corresponding Country Residential 
        Purchase Contract so that it forms part of the same transaction.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Buyers and Sellers:</strong> Insert all Buyers and Sellers
        names as indicated on page 1 of the Contract.</p>`,
      },
      {
        x: `1.5%`,
        y: `23%`,
        data: `<p><strong>Representations & Warranties (1.1):</strong> This 
        section deals with the availability and access to essential services 
        and infrastructure for the property being sold. The Seller makes 
        specific representations and warranties about what is included or 
        excluded with the property.</p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Representations & Warranties (1.2):</strong> This 
        section is all about the Seller disclosing important legal and 
        utility-related information about the property to the Buyer. It 
        ensures transparency around rights, contracts, and key 
        infrastructure, which can significantly affect the property's 
        value, use, and future development. Ensure you verify the details as 
        you complete this section.</p>`,
      },
      {
        x: `1.5%`,
        y: `77%`,
        data: `<p> If the there are any unpaid fees to provide services to 
        the property, complete this section. Such examples could include: 
        installation/connection fees, local improvement levies/special assessments, 
        community service charges...etc.</p>`,
      },
      {
        x: `1.5%`,
        y: `85%`,
        data: `<p>This statement clarifies that if any known environmental issues 
        that will affect the use of the property have been disclosed in writing.
        </p>`,
      },
      {
        x: `19%`,
        y: `91.25%`,
        data: `<p>Have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1032,
    form: `country-schedule`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/RPS-country/country-schedule-2.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number is to be completed on all pages and can be 
        your own personal identifier for the specific offer being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Other Terms:</strong> If the Seller is providing reports, 
        as listed in this section, checkbox the ones that apply and note the date of
        the report being provided. It's important, as per the statement, that
        the Seller is not providing any warranty regarding the accuracy of the 
        provided reports.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `26%`,
        data: `<p>If there are any contracts to be assumed by the Buyer, insert 
        the details of those contracts here.</p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Signatures:</strong> Have all parties to the contract 
        sign in the specified locations along with their date of signing.</p>`,
      },
    ],
  },
  {
    id: 1041,
    form: `manufactured-schedule`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/Manufactured-schedule/manufactured-home-schedule.png",
    description: `<p>The Manufactured Home Schedule ensures that all key information 
    about a manufactured (mobile) home is accurately disclosed during a sale or 
    purchase. It includes details like the make, model, year, serial number, and 
    dimensions. It clarifies land ownership—whether the home sits on rented, leased, 
    or owned land. If on leased land, it clarifies details regarding the lease costs  
    and restrictions. This helps protect both the Buyer and Seller by ensuring 
    transparency.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `11%`,
        data: `<p><strong>Contract Number:</strong> Enter the number that matches 
        the associated Purchase Contract Number.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyers and Sellers:</strong> Insert all Buyers and Sellers
        names as indicated on page 1 of the Contract.</p>`,
      },

      {
        x: `1.5%`,
        y: `21%`,
        data: `<p><strong>Manufactured Home Details:</strong> Insert 
        details of the manufactured home here. If certain information does not 
        apply, you can leave it blank or insert "N/A". Most of the information 
        is typically found on the Data Plate which is usually located in the 
        master bedroom closet, kitchen cabinet, or electrical panel. The Data Plate 
        also proves the home was built to HUD standards.
        <ol class="letter-ol">
        <li>Manufacturer: Insert the name of the manufacturer here.</li>
        <li>Model: Insert the model of the manufactured home here.</li>
        <li>Serial Number: Insert the serial number of the manufactured home here. 
        This can typically found on the Data Plate or it can be stamped on 
        the home's frame.</li>
        <li>Year: Insert the year the manufactured home was built here.</li>
        <li>CSA Registration Number: This label indicates that the home has 
        been certified to meet specific Canadian safety and quality standards. 
        It is usually located near the electrical panel or inside a kitchen 
        cabinet. Insert the CSA registration number here.</li>
        <li>Foundation Details: Insert the foundation details here, if applicable.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Land Lease Details:</strong> Insert 
        details of the land lease here. All this information is typically found 
        within the Land Lease Documents.
        <ol class="letter-ol">
        <li>Monthly Rent: Insert the monthly rent here.</li>
        <li>What is included in the rent: Insert what is included in the rent here.</li>
        <li>Occupancy Restrictions: Insert the occupancy restrictions here.</li>
        <li>Other: Insert any other details here that may be important to the Buyer.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `49%`,
        data: `<p><strong>Buyer to verify (2.2):</strong> This statement dictates that 
        the Buyer is responsible for verifying the stated information.</p>`,
      },
      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>Signatures:</strong> Have all parties to the contract 
        sign in the specified locations along with their date of signing.</p>`,
      },
    ],
  },
  {
    id: 1051,
    form: `seller-cust-fee-agreement`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/seller-cust-fee-Agreement/seller-cust-fee-Agreement-1.png",
    description: `<p>This form is used when a Seller chooses not to be represented by 
    an Agent but agrees to pay a fee for limited services. It clarifies that the 
    Seller is a Customer, not a Client, and the Agent doesn't owe fiduciary 
    duties. The form outlines the services provided, such as passing along 
    information and offers, and specifies the Seller's obligation to pay a fee 
    upon the sale of the property. This Agreement ensures transparency and protects 
    both parties.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Brokerage & Sellers:</strong> Ensure that you input the 
        complete legal names of the Sellers along with the Brokerage name. Take the extra
        step of cross-referencing their IDs to guarantee accuracy. If the client is a 
        corporation, be sure to obtain documents, such as the Articles of Incorporation, 
        to confirm signing authority. Verify the Seller names in the Land Title document.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `24%`,
        data: `<p><strong>The Property (Section 1):</strong> Insert the 
        full Municipal Address as well as the full Legal Description of the 
        property here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Brokerage/Agent Role (Section 2):</strong> 
        This section explains that the Brokerage/Agent will not act as your Agent. 
        The Seller acknowledges that they have read and understood this Agreement 
        and the Consumer Relationships Guide. By choosing not to have an Agent, 
        the Seller forgoes the advantages and protection that come with agency. 
        The Seller further understands that the Brokerage/Agent has no fiduciary 
        obligations to the Seller and cannot provide advice or act in their best 
        interests, as the Brokerage/Agent represents the Buyer and must act in 
        their best interests.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `60%`,
        data: `<p><strong>Brokerage/Agent Responsibilities (Section 3):</strong> 
        The Brokerage/Agent must act honestly, exercise reasonable care, and 
        hold any money received in trust as required by law. The 
        Brokerage/Agent will comply with the Real Estate Act and its regulations, 
        identify the Buyer after entering into this fee Agreement, and provide 
        the Seller with a copy of this Agreement as soon as possible after signing.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `72%`,
        data: `<p><strong>Brokerage/Agent Services (Section 4):</strong> 
       The Brokerage/Agent may provide property statistics, offer assistance 
       with purchase agreements, and supply names of real estate service 
       providers without recommending any specific ones. They will present all 
       offers and counteroffers, share relevant information with the Buyer, and 
       keep the Seller updated on the progress.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `85%`,
        data: `<p><strong>Brokerage/Agent Fee (Section 5):</strong> 
       Insert the agreed upon fee here for the completion of the transaction 
       associated with this Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL Sellers 
        initial on the line that applies. Additionally, insert your 
        initials in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1052,
    form: `seller-cust-fee-agreement`,
    page: `2`,
    imageURL:
      "../../images/Yukon/forms/seller-cust-fee-agreement/seller-cust-fee-agreement-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.</p>`,
      },
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>Brokerage/Agent Fee continued (Section 5):</strong> 
       As per this section, The Seller must pay the fee within a specified number 
       of days after the sale is completed if the Buyer enters into a legally 
       binding contract. If the sale is not completed, the fee is still due unless 
       the Seller has a legal reason for not completing it. The fee will not be 
       owed if the Buyer does not complete the sale. The Seller authorizes the 
       Brokerage to use the deposit towards the fee and instructs their lawyer 
       to deduct any outstanding balance from the sale proceeds. The Brokerage is 
       entitled to encumber the property to secure payment, and if legal 
       enforcement is needed, the Seller will cover the costs, including legal 
       fees.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Personal and Property Information (Section 6):</strong> 
       As per this section, The Seller understands that the Brokerage/Agent can 
       gather information about the property from various sources, including 
       individuals, corporations, government bodies, or municipal agencies. The 
       Brokerage/Agent can collect, use, and disclose personal and property 
       information provided by the Seller for purposes related to selling the 
       property as well as use and disclose this information for statistical 
       purposes.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Audio/Video Recording and Photography (Section 7):
        </strong> In this section, The Seller consents to the property being 
        shown, including virtual showings with photography or videography, and 
        acknowledges that their personal or confidential information may be 
        viewed by potential Buyers and others involved. The Seller releases us 
        and our representatives from any legal liability related to privacy 
        breaches during property showings. The Seller also acknowledges that 
        recording conversations without consent and using active cameras in 
        private areas of the property are unlawful.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `40%`,
        data: `<p><strong>End of this Agreement (Section 8):</strong> 
        As per this statement, the Brokerage/Agent or the Seller may terminate 
        this agreement at any time as long as they provide it in writing. All 
        rights under this Agreement remain unaffected by this termination.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Other Details about this Agreement (Section 9): 
        </strong> Any changes to this Agreement must be in writing and signed 
        by both parties to be valid. If there are conflicts between added 
        clauses and standard ones, the added clauses take precedence. This 
        Agreement is the entire understanding between the parties, and only 
        what is written here is included. The laws of Yukon govern this 
        Agreement, and a sale is considered complete when all funds are paid 
        and releasable to the Seller. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `56%`,
        data: `<p><strong>Seller Acknowledgement (Section 10): 
        </strong> The Seller acknowledges that they have read this Agreement 
        and the Guide, and understand that it does not make the Brokerage their 
        agent. The Seller had the opportunity to seek independent advice from
        professionals before signing, and this Agreement accurately reflects the 
        terms agreed upon.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `70%`,
        data: `<p><strong>Contact Information (Section 11):</strong> Complete this section with 
        all of the Seller's current contact information as well as the Brokerage and 
        the Brokerage Representative's contact information. It is important to ensure 
        the details contained in this section are accurate so that either the Seller, 
        Brokerage, Designated Agent or any other party in possession of this agreement 
        can make contact if needed. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL Sellers 
        initial on the line that applies. Additionally, insert your 
        initials in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1053,
    form: `seller-cust-fee-agreement`,
    page: `3`,
    imageURL:
      "../../images/Yukon/forms/seller-cust-fee-agreement/seller-cust-fee-agreement-3.png",
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.</p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Signatures:</strong> Insert the date when this agreement is 
        to be signed. Have all of the parties to this agreement 
        sign in this section. Be sure to not only have the signature but also the 
        printed name of the party signing. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL Sellers 
        initial on the line that applies. Additionally, insert your 
        initials in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1061,
    form: `cust-acknowledgement`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/customer-acknowledgement/cust-acknowledgement-1.png",
    description: `<p>This Form is used to clarify that a person is not being 
    represented by an Agent as a Client, but rather as a Customer. It outlines the 
    limited services the Agent will provide and explains that the Agent does not owe 
    fiduciary duties, such as acting in the Customer's best interests. The form also 
    ensures that the Customer understands their obligations as well as the 
    Brokerage/Agent's responsibilities. It helps establish transparency, protects 
    both parties, and ensures that the roles and responsibilities are clear in the 
    transaction.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to 
        be completed on all pages and can be your own personal identifier for 
        the specific Agreement being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Brokerage, Buyer OR Seller Names:</strong> Insert the name 
        of the Brokerage as well as the name of the Buyers or Sellers that will be 
        the customer in the transaction. If the Customer is a Seller, insert the 
        Sellers names instead. Only insert the side that will be a customer in 
        the transaction.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>The Property (Section 1):</strong> Insert the 
        full Municipal Address of the property here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Brokerage/Agent Role (2.1):</strong> The Seller 
        acknowledges that the Brokerage will not act as their agent. By signing 
        this acknowledgment, the Seller confirms they understand the Consumer 
        Relationships Guide and have chosen not to have an Agent represent them, 
        meaning they will not receive the protections or services of an agency 
        relationship.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `37.5%`,
        data: `<p><strong>Brokerage/Agent Role (2.2):</strong> Check the box that 
        applies to this transaction. 
        <ol>
          <li><strong>First box:</strong> check if you represent the Seller in this transaction</li>
          <li><strong>Second box:</strong> check if you represent the Buyer in this transaction</li>
        </ol>
        Additionally, this section further explains that as the Client's Agent, the 
        Brokerage/Agent has a duty to remain loyal, act in the Client's best 
        interests, disclose all information provided by the Customer (unless 
        received while acting as their agent), and refrain from offering the 
        Customer advice that could conflict with the Client's interests.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `53%`,
        data: `<p><strong>Brokerage/Agent Responsibilities (Section 3):</strong> 
        The Brokerage/Agent must act honestly, use reasonable care when providing 
        services, follow the Real Estate Act and related rules, hold any money 
        received in trust, and provide the Seller with a copy of this acknowledgment 
        promptly after signing.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Brokerage/Agent Services (Section 4):</strong> 
        The Brokerage/Agent may choose to provide property statistics, help 
        complete Purchase Agreements, share names of service providers (without 
        recommendations), present all offers and counter-offers, pass along 
        information to their Client that the Seller wants shared, and keep the 
        Seller updated on progress.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `76%`,
        data: `<p><strong>No Fees (Section 5):</strong> 
        A simple statement that the Customer will not be charged any fees for 
        the services provided by the Brokerage/Agent.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `80%`,
        data: `<p><strong>Personal and Property Information (Section 6):</strong> 
        The Customer acknowledges that the Brokerage/Agent can gather property 
        information from various sources, use personal and property details provided 
        for purposes related to selling the property, and use this information 
        for statistical purposes.
        </p>`,
      },
      {
        x: `22%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL Customers 
        initial on the line that applies. Additionally, insert your 
        initials in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1062,
    form: `cust-acknowledgement`,
    page: `2`,
    imageURL:
      "../../images/Yukon/forms/customer-acknowledgement/cust-acknowledgement-2.png",
    description: `<p>enter description here.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to 
        be completed on all pages and can be your own personal identifier for 
        the specific Agreement being made.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Customer Acknowledgement (Section 7):</strong> The Customer 
        acknowledges reading and understanding the acknowledgment and the Guide, 
        confirms that this does not create an agency relationship, had the chance 
        to get independent advice, and agrees the document reflects their mutual 
        understanding.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Contact Information (Section 10):</strong> Complete this 
        section with all of the Customer's current contact information as well as 
        Brokerage and the Brokerage Representative's contact information. It is 
        important to ensure the details contained in this section are accurate so 
        that either the Customer, Brokerage, Brokerage Representative or any other 
        party in possession of this agreement can make contact if needed.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Signatures:</strong> Insert the date when this 
        acknowledgement is to be signed. Have all of the parties to this acknowledgement 
        sign in this section. Be sure to not only have the signature but also the 
        printed name of the party signing. 
        </p>`,
      },
    ],
  },
  {
    id: 1061,
    form: `addendum`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/addendum/addendum-1.png",
    description: `<p>An Addendum is used to include extra information in a Contract 
    without changing the original terms or intentions of the Agreement. Ideally, it's 
    added before the Contract is finalized and simply supplements the deal—like 
    listing additional items included in a sale that couldn't fit in the main 
    document. Addendums are also useful for explaining complex terms or conditions 
    in more detail. When prepared ahead of signing and referenced in the Contract, 
    the Addendum becomes a valid part of the Agreement. If an Addendum is being added 
    after the contract is fully signed by all parties, it would have to inserted 
    into the Agreement by way of an Amendment.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `11%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number will 
        be the same as the Purchase Contract Number so that it refers to that 
        Contract.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p>Insert the names of the Buyers and Sellers as well as the 
        Municipal Address of the property here.</p>`,
      },
      {
        x: `1.5%`,
        y: `26%`,
        data: `<p>Insert any additional terms and conditions that will form part 
        of this Purchase Contract here.</p>`,
      },
      {
        x: `1.5%`,
        y: `69%`,
        data: `<p>Enter the date and time the Purchase Contract was signed, 
        and include the full names and signatures of all parties involved.
        </p>`,
      },
    ],
  },
  {
    id: 1071,
    form: `agreement-to-rep-both`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/agreement-to-rep-both/agreement-to-rep-both-1.png",
    description: `<p>This form is used when the same Designated Agent is working with 
    both the Buyer and the Seller in the same transaction. It clearly informs both 
    parties the agent is representing both sides, helping maintain transparency. It 
    outlines the Agent's limited responsibilities as a transaction facilitator, 
    ensuring fairness and compliance with real estate laws. If one party is not 
    comfortable with this arrangement, then the Designated Agent would have to 
    release one party as a client.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Brokerage and Client Names:</strong> Insert the name 
        of the Brokerage as well as the name of the Buyers and Sellers here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `21%`,
        data: `<p><strong>The Property (Section 1):</strong> Insert the 
        full Municipal Address as well as the full Legal Description of the 
        property here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Consumer Relationships Guide (Section 2):</strong> 
        This section explains that this Agreement applies when one Agent 
        represents both the Buyer and Seller for a specific property transaction. 
        Both parties confirm they've read the Consumer Relationships Guide and 
        understand the Agent's limited role. If the deal doesn't go through, the 
        Agent returns to their full responsibilities as outlined in each party's 
        original Agreement.
       
        </p>`,
      },
      {
        x: `1.5%`,
        y: `48%`,
        data: `<p><strong>Designated Agent's Responsibilities (Section 3):</strong> 
        In short, this section explains that the Designated Agent must treat 
        both the Buyer and Seller fairly, follow their lawful instructions, use 
        reasonable care and skill, follow all real estate laws and rules, avoid 
        favouring one party over the other, and provide a copy of this signed 
        Agreement promptly.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `60%`,
        data: `<p><strong>Designated Agent's Responsibilities About Information 
        (4.1):</strong> The Designated Agent must be honest, share all 
        offers and counter-offers, pass along any information the other party 
        wants communicated, keep both parties updated, and disclose what 
        information they've shared. They must also inform the Buyer of any 
        hidden property defects and inform the Seller about the Buyer's 
        ability to purchase. However, they cannot share certain confidential 
        details outlined in clause 4.2.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `75%`,
        data: `<p><strong>Designated Agent's Responsibilities About Information 
        (4.2):</strong> The Designated Agent cannot share either party's price 
        flexibility, reasons for Buying or Selling, or any personal/confidential 
        information without written consent from the other party.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `82%`,
        data: `<p><strong>Our Facilitation Services (Section 5):</strong> <br/>
        <strong>Brokerage: </strong> The Brokerage will ensure the Designated 
        Agent follows company policies, treats both parties fairly, is properly 
        supervised, and that any money received is held in trust as required by 
        law.
        <br/>
        <strong>Designated Agent (top of next page): </strong> The Designated 
        Agent will help both parties negotiate, provide property and market 
        information, prepare necessary documents, and offer a list of 
        professional contacts, when requested, without recommending any specific 
        provider.
        </p>`,
      },
      {
        x: `17%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL parties 
        initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1072,
    form: `agreement-to-rep-both`,
    page: `2`,
    imageURL:
      "../../images/Yukon/forms/agreement-to-rep-both/agreement-to-rep-both-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Designated Agent's Services Don't Include (Section 6):</strong> 
        The Designated Agent won't independently verify property details or 
        financial information. For the Buyer, they won't arrange or influence 
        inspections unless asked. For the Seller, they won't check or influence 
        the Buyer's financial status.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Fees (Section 7):</strong> 
        As per this statement, both sides agree to pay the Designated Agent's 
        fees.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `33.5%`,
        data: `<p><strong>Other Details about this Agreement (Section 8):</strong> 
        This section explains that any information the Designated Agent knows 
        about one party won't be shared with the other. Neither party is 
        responsible for the Agent's actions. Any changes to the Agreement must 
        be in writing and signed by everyone. The Agreement is the full and 
        final Contract, and both parties confirm they've read it, had the chance 
        to get professional advice, and agree to its terms.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>Contact Information (Section 9):</strong> 
        Complete this section with all of the parties current contact information 
        as well as the Brokerage and Designated Agent's contact information. It 
        is important to ensure that the details contained in this section are 
        accurate, so that either party, the Brokerage, Designated Agent, or any 
        other party in possession of this agreement, can make contact if 
        needed. 
        </p>`,
      },
      {
        x: `17%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL parties 
        initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1073,
    form: `agreement-to-rep-both`,
    page: `3`,
    imageURL:
      "../../images/Yukon/forms/agreement-to-rep-both/agreement-to-rep-both-3.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the 
        Agreement Number of the associated Contract.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>Risks with Communications:</strong> Ensure that you 
        explain the risks associated with the communication of information 
        between the parties, as described in this section.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Signatures:</strong> Insert the date when this agreement is 
        to be signed. Have all of the parties to this agreement 
        sign in this section. Be sure to not only have the signature but also the printed 
        name of the party signing. Also note, that you will sign at the bottom of 
        this section along with your printed name.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Acknowledgement that all parties received copy of the Agreement:
        </strong> Each party should provide their initials, date, and time in this 
        section to confirm they have received a copy of the agreement.
        </p>`,
      },
    ],
  },
  {
    id: 1081,
    form: `ESRA`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-1.png",
    description: `<p>This form establishes a formal relationship between a 
    Seller and a real estate agent/Brokerage, outlining the terms under which 
    the agent will market and sell the property. It includes key details such 
    as the listing price, commission structure, duration of the Agreement, and 
    the responsibilities of both the Seller and the Agent.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `3%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Brokerage & Sellers:</strong> Insert the Brokerage name and 
        the complete legal names of the Sellers. Take the extra step of cross-referencing 
        your clients' IDs to guarantee accuracy. If the client is a corporation, be 
        sure to obtain documents, such as the Articles of Incorporation, to 
        confirm signing authority. Obtain the Land Title document to verify all the 
        names that should be on the agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>Municipal Address: </strong>Enter the full municipal 
        address of the property.  Verify the address details in the Land Title 
        document. Keep in mind that the title does not always match the  
        municipal address. For example, in the case where the property is used  
        as an income property.</p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,

        data: `<p><strong>Unattached Goods:</strong> These are items that are to 
        be included in the sale price and typically involve items not fixed  
        to the property. 
        Chattels are movable items such as: appliances, garage door remotes, mirrors
        not fixed to the walls...etc. It is important to be as detailed as possible
        when describing the chattels to be included.</p>`,
      },
      {
        x: `1.5%`,
        y: `36%`,
        data: `<p><strong>Attached Goods Excluded:</strong> These are items that are
        attached to the home but the Seller wishes to exclude them from the sale. 
        One reason may be that the item listed has sentimental value like a lighting 
        fixture. Some items such as fixed tv mounts have been greatly debated as to  
        whether they are a chattel or a fixture. 
        As a rule of thumb, "if in doubt, include it" so that it is clear to all 
        parties. Precision is key when itemizing excluded fixtures, for instance, 
        specifying "bedroom light fixture." </p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Legal Description:</strong> Verify the legal 
        description in the Land Title document and insert the details here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `51%`,
        data: `<p><strong>Additional Schedules:</strong> If the property being listed 
        is either a Condo or Country Property, check the box that applies and complete 
        the appropriate schedule in addition to this Agreement. If the property being 
        listed is a Manufactured/Mobile Home, complete the necessary Schedule and add 
        it to this Agreement by completing Section 18.1.</p>`,
      },

      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>List Price (1.2):</strong> This is the agreed upon list price  
        for the property. The price almost always includes GST. If you 
        are unsure or feel that GST might be applicable, you should always refer the 
        client to an accountant or lawyer in order to get professional advice on the 
        matter. If GST is applicable, be sure to include a term 
        in the incoming purchase contract that addresses that all parties are aware 
        GST may be applicable and who will be responsible for paying it.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `59%`,
        data: `<p><strong>Possession Date (1.3):</strong> This is the date that the 
        Seller will be able to move out of the property. This date is important 
        to the Seller as they will be required to move out of the property by this 
        date. This can either be a specific date or a range (example: 30-60 days).
        </p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Designated Agent(s) (2.1/2.2):</strong> 
        This is the agent that the Seller has designated to handle the listing. 
        Insert the name of the agent(s) here.
        This Agreement creates a sole agency relationship between the Seller and 
        the designated agent(s). As per 2.2, if the designated agent leaves the 
        Brokerage the Seller will have the choice for another designated agent to 
        be appointed or the Agreement will be terminated.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `74%`,
        data: `<p><strong>Listing Period (2.4):</strong> This is the agreed upon 
        time frame for which the agent will be marketing the property for sale. Enter 
        the listing's start and expiration dates.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `79%`,
        data: `<p><strong>Section 3:</strong> As noted in this section, these are 
        the responsibilities of the real estate Brokerage. It is important to 
        review this section with your client to ensure that all parties are aware of 
        their obligations and responsibilities.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `87%`,
        data: `<p><strong>Section 4:</strong> This section outlines the 
        responsibilities of the designated agent(s). It is important to 
        review this section with your client to ensure that all parties are aware of 
        their obligations and responsibilities. This section continues on the next 
        page.
        </p>`,
      },
      {
        x: `17%`,
        y: `92%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1082,
    form: `ESRA`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `3%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>MLS System Services (5.1):</strong> This section covers 
        some of the basic rules surrounding the MLS System such as: the listing needs 
        to be a minimum of 60 days, it must offer payment to cooperating brokers and 
        cannot exclude any licensed agent from participating as a cooperating broker.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `32%`,
        data: `<p><strong>Additional Services (5.2-5.3):</strong> Insert any additional 
        services that will be provided to the Seller during the listing period. 
        As per (a), check the box that applies with respect to the installation of 
        a lockbox. Add any additional services on the other lines.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `39%`,
        data: `<p><strong>Seller Responsibilities (6.1):</strong> This section 
        outlines the responsibilities of the Seller during the listing period. 
        It is important to review this section with your client to ensure that all 
        parties are aware of their obligations and responsibilities.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>6.2:</strong> This clause states that the Seller must give 
        the Brokerage copies of any offers received during the Agreement and for 90 
        days after it ends, unless a new ESRA is signed with another 
        Brokerage. The purpose of this clause is to see whether or not the Holdover 
        Clause in section 10.3 is applicable.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `59%`,
        data: `<p><strong>Seller's Warranties/Representations (Section 7):</strong> 
        This section outlines the Seller's warranties and representations about the 
        property. It's important to review this section with your client to ensure 
        that all parties are aware of their obligations and responsibilities.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `79%`,
        data: `<p><strong>Conflicts of Interest (Section 8):</strong> This part talks 
        about conflicts of interest when the real estate agent (the designated agent) 
        is working with both the Seller and a potential Buyer. It outlines different 
        scenarios that might lead to a conflict of interest and explains the 
        choices available in each case. If your client has any questions, you should 
        be prepared to explain each point clearly and professionally.
        </p>`,
      },
      {
        x: `17%`,
        y: `92%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1083,
    form: `ESRA`,
    page: `3`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-3.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `3%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created.</p>`,
      },

      {
        x: `1.5%`,
        y: `13%`,
        data: `<p><strong>Total Commission (9.1):</strong> This is the total amount 
        of commission for the sale of the property. Insert the agreed upon 
        amount here. GST is added to the amount indicated in this section.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Buyer's Brokerage Commission (9.2):</strong> This is 
        the portion of the total commission that will be offered to the Buyer's 
        Brokerage (if one exists). Insert the agreed upon amount here. GST is added 
        to the amount indicated in this section. If there is no Buyer's Brokerage, 
        the total commission still applies and is not reduced by the amount indicated 
        in this section.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Holdover Clause (9.3):</strong> This clause lets the 
        Brokerage still earn a fee if the Seller accepts an offer from a Buyer 
        who was introduced to the property during the ESRA, as long as it's within 
        90 days after the Agreement ends. This clause also includes 
        situations where the Seller finds their own Buyer during the term of this 
        Agreement. It's important to note that the 
        Seller isn't responsible for any fees under this Agreement if they enter a 
        new ESRA with a different Brokerage after this one expires.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>9.4:</strong> The Seller agrees that the Brokerage can use 
        any deposit it holds from the property sale to cover what's owed under this 
        Agreement. If the deposit doesn't fully cover the amount, the Seller will 
        pay the remaining balance within 7 days.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `37%`,
        data: `<p><strong>9.5/9.6:</strong> These parts of the Agreement state 
        that the Seller must have their lawyer use the sale proceeds or deposit 
        to cover any amounts owed, and describe the situations where the Seller 
        isn't required to pay the Brokerage.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>9.7:</strong> If the Seller decides not to sell the 
        property anymore, they need to let you know in writing. As per the statement, 
        they also have to pay you back for any reasonable costs you've already spent 
        trying to sell the property up to that point. These are things like advertising 
        or marketing expenses. If applicable, list the services and associated costs 
        to be reimbursed in this circumstance. Additionally, the Seller is not 
        released from their obligation to pay the Brokerage for any other fees that 
        may be owed under this Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `50%`,
        data: `<p><strong>9.8:</strong> If the Buyer backs out of the sale without a 
        legal reason, they might lose their deposit. If that happens, the Seller 
        agrees to pay the Brokerage either the full fee or half of the lost deposit, 
        whichever amount is smaller.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `54%`,
        data: `<p><strong>9.9-9.10:</strong> The Seller agrees that if they owe 
        money under this Agreement, a legal claim can be placed (called an 
        encumbrance) on the property to help secure payment. If legal action is needed 
        to enforce these rights, the Seller will also be responsible for paying 
        the reasonable legal costs, including lawyer fees.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Section 10:</strong> This section outlines the following: 
        By signing this Agreement, the Seller allows the real estate Brokerage to 
        collect, use, and share their personal and property-related 
        information—called "Listing Information"—to help list, market, and sell 
        the property. This includes things like their name, property address, photos, 
        videos, pricing, and sale details. The information may be shared with other 
        professionals, databases, and organizations involved in real estate, and 
        used for things like market analysis and statistics. The Brokerage agrees 
        not to use or share the Seller's information beyond what is stated here or 
        required by law, and won't share confidential information from past clients.
        </p>`,
      },
      {
        x: `18%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1084,
    form: `ESRA`,
    page: `4`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-4.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Section 12:</strong> In this section the Seller agrees to 
        allow in-person and virtual showings of the property, and understands that 
        personal or private information may be seen by potential Buyers and others. 
        The Seller agrees to not hold the Brokerage responsible for any privacy 
        issues that may come up during these showings. Also, they acknowledge that 
        it is illegal to record people's conversations or have active cameras 
        in private areas without their written consent.</p>`,
      },
      {
        x: `1.5%`,
        y: `24%`,
        data: `<p><strong>Section 13:</strong> In this section the Seller agrees to 
        protect the Brokerage/agent from any legal trouble that might come up because 
        of something the Seller agreed to or told the Brokerage/agent in this Agreement. 
        If someone makes a claim or takes legal action and it's based on the Sellers 
        provided info or consent, they will cover all costs, including legal fees.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `32%`,
        data: `<p><strong>Property Information, Notices and Permits (Section 14):
        </strong> This section addresses the fact that the Seller is required to 
        disclose material latent defects. The statement further explains common 
        examples of latent defects and the Seller's responsibility to disclose them. 
        As per the section, answer the questions by checking the box that applies. 
        If any of the answers are yes, then complete the Defect Disclosure Instruction 
        Schedule and include its existence in the Agreement in section 18.1
        </p>`,
      },
      {
        x: `1.5%`,
        y: `46%`,
        data: `<p><strong>Additional Terms (Section 15):</strong> Add any additional 
        terms that will form part of this Agreement. If you require more space, you 
        can attach an addendum to this Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `61%`,
        data: `<p><strong>Early End to this Agreement (Section 17):</strong> This 
        section outlines circumstances in which the Agreement could end early. 
        If your client has any questions, you should be prepared to explain each 
        element clearly and professionally. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `70%`,
        data: `<p><strong>Other Details about this Agreement (Section 17.1-17.2):</strong> 
        List any additional documents that will form part of this Agreement. As per 
        17.2, any changes to this Agreement in the future must be agreed to by 
        both parties in writing.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `79%`,
        data: `<p><strong>Section 17.3-17.8:</strong> This section continues to 
        explain that singular words can be understood as plural if needed, and 
        if any new clauses are added that conflict with the original terms, the 
        new ones will apply. The Agreement includes only what's written—past 
        discussions don't count unless they are in writing here. It's legally 
        binding on both parties and their heirs or successors, is governed by 
        Yukon law, and a sale is considered complete once all the money 
        is paid and ready to be released. </p>`,
      },
      {
        x: `18%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1085,
    form: `ESRA`,
    page: `5`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-5.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `3%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created.</p>`,
      },

      {
        x: `1.5%`,
        y: `8%`,
        data: `<p><strong>Seller Acknowledgement:</strong> The Seller 
        acknowledges here that they have read this Agreement and the Consumer 
        Relationships Guide, and understand that it creates a sole agency 
        relationship with the designated agent. The Seller also acknowledges they had 
        the chance to seek independent professional advice before signing and confirms 
        that the Agreement accurately reflects the terms agreed upon with the 
        Brokerage. </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Contact Information:</strong> Complete this section with 
        all of the Seller's current contact information as well as the Brokerage and 
        the Brokerage Representative's contact information. It is important to ensure 
        the details contained in this section are accurate so that either the Seller, 
        Brokerage, Designated Agent or any other party in possession of this Agreement 
        can make contact if needed. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Signatures:</strong> Insert the date when this Agreement is 
        to be signed. Have all of the parties to this Agreement 
        sign in this section. Be sure to not only have the signature but also the printed 
        name of the party signing. 
        </p>`,
      },
    ],
  },
  {
    id: 1091,
    form: `EBRA`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-1.png",
    description: `<p>This form is used to clearly define the relationship between a 
    Buyer and a Brokerage/Agent. This agreement outlines the duties and 
    responsibilities of all parties during the homebuying process. Some of the key 
    elements include: agent's duties, buyer's obligations, duration of the agreement, 
    commission, and confidentiality. Ensure you explain all of the terms and conditions 
    to the Buyer before signing.
       </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific Agreement being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Brokerage and Client Names:</strong> Ensure that you input 
        the complete legal names of your Buyers. Take the extra step of
        cross-referencing your clients' IDs to guarantee accuracy. If the client is 
        a corporation, be sure to obtain documents, such as the Articles of 
        Incorporation, to confirm signing authority.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>Property/Search Criteria:</strong> Complete this section by 
        listing the Property Types and Market Areas that the Buyer is interested in. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Designated Agent:</strong> Insert the name(s) of the 
        Designated Agent(s) for the Buyer. This means that only the named agent(s) 
        in this Agreement can represent the Buyer in a transaction with the 
        specified search criteria.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `42%`,
        data: `<p><strong>Agreement Duration (2.4):</strong> Insert the agreed upon 
        start and end dates of the Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Brokerage Responsibilities (Section 3):</strong> This section 
        describes the responsibilities of the Brokerage which are as follows: during 
        this Agreement, the Brokerage must stay neutral when dealing with the Buyer 
        and other Sellers it represents, ensure the designated agent representing 
        the Buyer follows company policies, and properly supervise the agent and 
        staff. The Brokerage must also hold any money in trust as required by law 
        and give the Buyer a copy of the signed Agreement promptly.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `57%`,
        data: `<p><strong>Designated Agent Responsibilities (Section 4):</strong> This 
        section describes the responsibilities of the Designated Agent(s) which are
        as follows: The designated agent must fulfill their responsibilities to the 
        Buyer in a timely way. This includes actively searching for suitable 
        properties, keeping the Buyer updated, and clearly identifying themselves 
        as the Buyer's agent. They must also provide relevant property information, 
        assist with making and negotiating offers, help the Buyer meet the terms 
        of any purchase contract, and present all offers and counteroffers—even if a 
        property already has an accepted offer.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `72%`,
        data: `<p><strong>Designated Agent's Other Services (Section 5):</strong> 
        Insert any other services that you will provide to the Buyer, assuming 
        all parties to this Agreement agree to the stated service.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `81%`,
        data: `<p><strong>Buyer's Responsibilities (Section 6):</strong> 
        This section describes the responsibilities of the Buyer which are as follows: 
        During this Agreement, the Buyer must communicate and cooperate with the 
        Brokerage/Agent, and share any specific information they want about a property—such 
        as undisclosed details or potential issues with buying. The Buyer also needs 
        to provide enough personal and financial information to help the Agent 
        assess their ability to purchase, and inform the agent of any inquiries 
        related to buying that could affect the Agreement.
        </p>`,
      },
      {
        x: `20%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1092,
    form: `EBRA`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific Agreement being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `11.5%`,
        data: `<p><strong>Buyer's Responsibilities (6.2):</strong> Enter the number 
        of days this clause applies to. It requires the Buyer to provide copies of 
        any offers on properties matching the search criteria made during the 
        Agreement and for the stated days after it ends, unless a new Buyer Agreement 
        has been signed with another Brokerage. Although not required, this number 
        typically matches the days in the Holdover Clause in Section 8.3 of this 
        Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Conflicts of Interest (Section 7):</strong> This section 
        deals with the potential conflicts of interest that may arise between the 
        Buyer and the Brokerage/Agent. Any potential conflict must be disclosed and 
        dealt with accordingly. It is extremely important to educate your client on 
        their options if a conflict arises. If the Buyer has any questions about 
        this section, you should be prepared to explain each element clearly and 
        professionally.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Fee for Service (8.1):</strong> Insert the agreed upon 
        fee for the services provided by the Brokerage/Agent. This fee is typically 
        a percentage of the purchase price of the property. While the Seller typically 
        pays the fee in a transaction, it is important to discuss with the Buyer any 
        scenarios in which the Buyer might be responsible for paying the fee well in 
        advance.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Retainer (8.2):</strong> If the Buyer has agreed to pay a 
        retainer up front, complete this section. As per the statement, any fee 
        collected will be applied to the fee as noted in 8.1 if a fee is owed under 
        this Agreement. If no fees are owed under this Agreement, the retainer will 
        be refunded to the Buyer unless stated otherwise in the "other" section 
        below. Be sure to include any agreed-upon conditions where the retainer 
        will not be refunded, along with the specific amount. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `46%`,
        data: `<p><strong>Holdover Clause:</strong> This clause lets the 
        Brokerage still earn a fee if the Buyer enters into a legally binding contract 
        that matches the search criteria of this Agreement, whether it involves the 
        Brokerage/Agent or not. This time frame extends beyond this Agreement for 90 
        days after the Agreement ends. Note that, as per Section 8.6, the 
        Buyer will not owe any fees under this Agreement if they sign a new EBRA 
        with another Brokerage once this one has expired. <br/><br/>It is important to 
        discuss this with the Buyer so that they understand their obligations 
        under this clause and the Agreement as a whole.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `66%`,
        data: `<p><strong>Reimbursement of Fees (8.8):</strong> Insert any reasonable 
        expenses, as agreed upon with the Buyer, that the Agent will be reimbursed 
        for if the Buyer chooses to end the Agreement early. Note that the Buyer 
        must provide written notice to the Agent before ending the Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `78%`,
        data: `<p><strong>Personal and Confidential Information (Section 9):</strong> 
        This section explains that the Buyer agrees to let the Brokerage collect 
        and use their personal information to help with buying a property. The 
        Brokerage, Real Estate Board, and listing services may also share 
        property-related information for things like reporting and statistics. 
        However, the Brokerage won't share or use the Buyer's confidential 
        information for any other purpose without consent, unless legally required, 
        and won't share private details from past clients.
        </p>`,
      },
      {
        x: `20%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1093,
    form: `EBRA`,
    page: `3`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-3.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific Agreement being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `12%`,
        data: `<p><strong>Ongoing Obligations (Section 10):</strong> As per this 
        short statement, it is important to note that the Brokerage/Agent's 
        responsibility to keep information confidential continues after this 
        Agreement ends.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `16%`,
        data: `<p><strong>Audio/Video Recordings & Photography (Section 11):</strong> This 
        section means the Buyer understands that some properties they view may 
        have cameras or recording devices, and the agent might not know they're 
        there. The Buyer agrees not to hold the agent or Brokerage responsible 
        for any privacy issues if the Seller records them during a showing.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `23%`,
        data: `<p><strong>Indemnification (Section 12):</strong> In this section, the 
        Buyer agrees to cover any costs, claims, or legal actions that result from
        the consents or information they provide in this Agreement. This includes 
        reimbursing the Brokerage for legal fees and related expenses if the 
        Brokerage acted in good faith based on that information.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>Additional Terms (Section 13):</strong> If applicable,
        insert any additional agreed upon terms that will form part of this Agreement 
        here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p><strong>Early End to this Agreement (Section 14):</strong> This 
        section explains scenarios in which the Agreement may end early. In summary,
        this Agreement will end early if certain events happen, such as the Buyer 
        purchasing a property, both parties agreeing to end it in writing, the 
        Brokerage losing its license, going bankrupt, or if either side seriously 
        breaks the Agreement and gives written notice. Even if the Agreement ends 
        for one of these reasons, both the Buyer's and Brokerage's rights under the 
        Agreement remains in place.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `55%`,
        data: `<p><strong>(15.1):</strong> As per the statement, only documents 
        attached to this Agreement form part of the Agreement. Insert any additional 
        documents that are to form part of the Agreement here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>(15.2-15.7):</strong> The remainder of this section is 
        summarized as follows: any changes to the Agreement must be in writing and 
        signed by both parties. Singular words may be interpreted as plural if 
        the context requires. If added clauses conflict with standard ones, the 
        added ones apply. This Agreement is the full and only Agreement between the 
        parties, and Yukon law governs it. A purchase is considered complete when 
        the seller or their lawyer receives all releasable funds.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `72.5%`,
        data: `<p><strong>Buyer Acknowledgement (Section 16):</strong> The Buyer 
        acknowledges they have read and understand the Agreement and the Consumer 
        Relationships Guide, recognize the sole agency relationship with the 
        Designated Agent, had the chance to seek legal advice, and agree that the 
        document reflects the full Agreement between them and the Brokerage.
        </p>`,
      },
      {
        x: `20%`,
        y: `91.5%`,
        data: `<p>As with most other pages within the Agreement, have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1094,
    form: `EBRA`,
    page: `4`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-4.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific Agreement being created.</p>`,
      },
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Contact Information:</strong> Complete this section with 
        all of the Buyer's current contact information as well as the Brokerage and 
        the Brokerage Representative's contact information. It is important to ensure 
        the details contained in this section are accurate so that either the Buyer, 
        Brokerage, Designated Agent or any other party in possession of this Agreement 
        can make contact if needed. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Signatures:</strong> Insert the date when this Agreement is 
        to be signed. Have all of the parties to this Agreement 
        sign in this section. Be sure to not only have the signature but also the 
        printed name of the party signing. 
        </p>`,
      },
    ],
  },
  {
    id: 1101,
    form: `ESRA-condo-sch`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-condo-sch-1.png",
    description: `<p>The purpose of this form is to: Collect important details about 
    the condominium property being sold, which aren't included in the standard 
    contracts. Clarify specifics such as parking and storage units, condo fees, 
    and what's included in the sale. Ensure transparency for the Buyer regarding 
    the condominium corporation's financials, bylaws, and any known issues with 
    the unit or common property. Confirm the Seller's responsibilities, including 
    providing documents like the Estoppel Certificate and details about the 
    condominium plan. Help avoid disputes by clearly laying out what is being 
    purchased and the Seller's disclosure obligations.</p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the Agreement 
        Number of the associated ESRA.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Property:</strong> Complete this section by filling in all 
        the property details using the legal description exactly as it appears in 
        the Land Title document for the specified property. If the Seller intends 
        to include all titled items, such as parking and storage, in the sale 
        price, make sure all relevant sections are fully completed. Additionally, if 
        there are non-titled Parking and Storage areas included with the property, 
        complete the appropriate sections based on their designations 
        (assigned/leased).</p>`,
      },
      {
        x: `1.5%`,
        y: `34%`,
        data: `<p><strong>Condominium Type:</strong> Check the box that applies to 
        the type of condominium property being listed. Both types of condos have common 
        areas with other owners and fees associated with maintaining them.
        <ol>
          <li><strong>Conventional Condominium: </strong> This type of condo has 
          multiple units inside of it, with the owner owning the unit's interior. 
          Apartment condos would be the best example of this type. </li>
          <li><strong>Bare Land Condominium: </strong> This type of condo involves 
          ownership of the land (a lot) and the building that is built on it. Common 
          examples include single family homes, townhouses, and duplexes. </li>   
        </ol>

      As noted, if the condo is a bare land condominium (where the unit includes a 
      piece of land), a Real Property Report (RPR) must be provided within 10 days 
      of signing this Agreement.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Documents and Information:</strong> As per the statement, 
        all documents and information listed below must be provided within 10 days  
        of signing this Agreement. Complete the sections below.
        <ol class="letter-ol">
          <li><strong>Name of Project: </strong> This typically refers to the name of 
          the building or development. In some cases the project name has not been 
          chosen yet. If this is the case, this can be left blank.</li>
          <li><strong>Management Company: </strong> Insert the name of the company 
          that manages the condominium. </li>   
          <li><strong>Phone Number: </strong> Insert the management company's 
          phone number. </li>   
          <li><strong>Email/Website Address: </strong> Insert the management company's 
          email and/or website address. </li>   
          <li><strong>Condominium Fee: </strong> Insert the monthly condominium fee. </li>   
        </ol>

        According to the documents section and the list below, this information—if 
        relevant—is included in the Estoppel Certificate and can be obtained by 
        the Seller directly from the condo corporation or management company.
        </p>`,
      },
      {
        x: `21%`,
        y: `91.5%`,
        data: `<p>Have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1102,
    form: `ESRA-condo-sch`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-condo-sch-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the Agreement 
        Number of the associated ESRA.</p>`,
      },
      {
        x: `1.5%`,
        y: `20%`,
        data: `<p><strong>Other Documents:</strong> Insert any additional documents 
        or information that is relevant to the property here.</p>`,
      },
      {
        x: `21%`,
        y: `91.5%`,
        data: `<p>Have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1111,
    form: `ESRA-country-sch`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-country-sch-1.png",
    description: `<p>The purpose of this document is to: Provide extra details 
    specific to country residential properties that aren't covered in the 
    standard contracts. Disclose important information about the property's utilities 
    and systems, such as water supply, sewage, septic systems, heating, and access 
    roads. Clarify boundaries and land use, including fences, outbuildings, zoning, 
    and agricultural or livestock use. Ensure transparency by helping the Seller 
    disclose all relevant information and helping the Buyer understand exactly what 
    they're purchasing. This reduces the risk of disputes by making sure both parties 
    are clear on the condition and features of the property.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the Agreement 
        Number of the associated ESRA.</p>`,
      },
      {
        x: `1.5%`,
        y: `16%`,
        data: `<p><strong>Property:</strong> Complete this section by filling in all 
        the property details using the legal description exactly as it appears in 
        the Land Title document for the specified property. Depending on the type 
        of the property, not all fields may be applicable. </p>`,
      },
      {
        x: `1.5%`,
        y: `30%`,
        data: `<p><strong>GST Notice:</strong> It is important to communicate to the 
        Seller that it is their responsibility to get professional advice in order to 
        determine if they are required to charge GST on the sale of the property. </p>`,
      },
      {
        x: `1.5%`,
        y: `35%`,
        data: `<p><strong>Documents and Information:</strong> To effectively market 
        and sell the property, gather answers and any necessary documents from 
        the Seller for the questions below, and complete this section with the 
        relevant details.</p>`,
      },
      {
        x: `19%`,
        y: `91.5%`,
        data: `<p>Have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1112,
    form: `ESRA-country-sch`,
    page: `2`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-country-sch-2.png",

    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the Agreement 
        Number of the associated ESRA.</p>`,
      },
      {
        x: `1.5%`,
        y: `53%`,
        data: `<p><strong>Additional Documents:</strong> Insert any addtional 
        information or documents that are relevant to the property.</p>`,
      },
      {
        x: `19%`,
        y: `91.5%`,
        data: `<p>Have ALL of your 
        clients initial on the line that applies. Additionally, insert your initials 
        in the appropriate location.
        </p>`,
      },
    ],
  },
  {
    id: 1121,
    form: `ESRA-dower-consent`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-dower-consent-1.png",
    description: `<p>This document is to be used when only one spouse is on the 
    title, but both have lived in the property during the marriage. The non-owner 
    spouse must provide legal consent before the property is sold, mortgaged, or 
    transferred. It aims to protect the rights of a spouse who is not listed on 
    property title. By completing this form, the spouse is giving up their dower 
    rights voluntarily, without pressure or influence from the owner spouse. Ensure 
    this form is fully completed which includes the completion by the legal official.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for this 
        document.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `14.5%`,
        data: `<p><strong>ESRA Reference Number:</strong> Insert the Agreement Number 
        of the associated Exclusive Seller Representation Agreement (found in the 
        top right corner of the ESRA).</br></br>
        <strong>Municipal Address:</strong> Fill in the complete municipal address 
        of the property that this consent applies to.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `20%`,
        data: `<p><strong>When to use this form:</strong> Use this form when there 
        is only one person on the property title and that person is legally 
        married (check the Land Title Document to confirm). It applies if either 
        the owner or their spouse has lived in the home during the marriage, 
        even if they are now separated and not divorced. This form is not used 
        for common-law relationships.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Other forms to sign:</strong> Refer to this list to keep 
        track of any forms that the non-owner spouse will be required to sign 
        throughout the sale process.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p>As per the first point, this consent form is not required  if 
        there is already a Release of Dower Rights registered on the property's title. 
        However, since that release can be canceled under the Dower Act, it's a good 
        idea to get legal advice if a Release of Dower Rights is on the title, just 
        to be safe and clear on the situation.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `50%`,
        data: `<p><strong>Consent of Spouse:</strong>  Complete this section using the 
        example provided. This is where the non-owner spouse will sign the form and 
        consent to the sale of the property.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Certificate of Acknowledgement:</strong> This part confirms 
        that the non-owner spouse met with a legal official alone, without their 
        husband or wife present, and they confirmed a few important things:
        <ol class="letter-ol">
          <li>They understand what the Sale or Agreement is about.</li>
          <li>They know the Dower Act gives them certain rights, like the right to 
          live in the property for life and the right to stop the sale.</li>
          <li>They are agreeing to give up those rights so the sale or Agreement can 
          go ahead.</li>
          <li>They are signing willingly, without being pressured by their spouse.</li> 
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `80%`,
        data: `<p> This portion will be completed by the legal official. It will 
        typically include a stamp and signature in order to confirm its completion.
        </p>`,
      },
    ],
  },
  {
    id: 1131,
    form: `ESRA-defect-disclosure`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-defect-disclosure-1.png",
    description: `<p>This form is used to clarify the Seller's responsibility 
    to disclose known material latent defects (issues that aren't visible 
    and could make the property dangerous or unfit to live in). It guides them on 
    what must be disclosed in order to protect themselves and the Buyer. It also 
    directs the Brokerage/Agent the defects known to the Seller and what to disclose. 
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for the  
        specific listing being created. The number here must match the Agreement 
        Number of the associated ESRA.</p>`,
      },
      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Brokerage Name:</strong> Insert the Brokerage Name that is 
        representing the Seller here.</p>`,
      },
      {
        x: `1.5%`,
        y: `19%`,
        data: `<p><strong>Disclosure of Material Latent Defects:</strong> It is 
        extremely important for the Seller to understand the need to disclose these 
        defects as per the law. The Seller must disclose all hidden defects that 
        they already know about, cannot be reasonably discovered by a Buyer and/or 
        could make the home unsafe or unlivable. If the Seller does not tell the 
        Buyer about these hidden issues, they could take legal action and potentially
        get money back (sue for damages) or cancel the sale (rescind the contract). 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Specifics of Material Latent Defects:</strong> In this 
        section, list the specific details of the material latent defects that the 
        Seller is disclosing. This is where the Seller will provide a detailed 
        description of the defect, including its location, severity, and potential 
        impact on the property's value or livability.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `39%`,
        data: `<p><strong>Disclosure of Other Defects/Information:</strong> A Seller is 
        not required to to point out obvious problems with the property. These are 
        called patent defects—things like cracks, stains, or other issues that are 
        clearly visible or can be found during a normal inspection. Even if they 
        might make the property harder to sell, the Seller is not required to mention 
        them, because the Buyer is expected to notice them themselves. If the Seller 
        wishes to disclose these, they can do so in this section.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p>In this section, list the specific details of any non-material 
        defects that the Seller wishes to disclose to the Buyer.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `57%`,
        data: `<p><strong>Legal Advice:</strong> It is important to note that the 
        Seller should seek legal advice to understand their obligations under the 
        law with respect to the disclosure of material latent defects. This 
        statement recommends as such and should be pointed out to the Seller.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p>Complete this section with the Seller's Signature, Printed Name 
        and Date.
        </p>`,
      },
    ],
  },
  {
    id: 1141,
    form: `purchase-contract-dower-consent`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/ResidentialPurchaseContract/purchase-contract-dower-consent-1.png",
    description: `<p>This document is to be used when only one spouse is on the 
    title, but both have lived in the property during the marriage. The non-owner 
    spouse must provide legal consent before the property is sold, mortgaged, or 
    transferred. It aims to protect the rights of a spouse who is not listed on 
    property title. By completing this form, the spouse is giving up their dower 
    rights voluntarily, without pressure or influence from the owner spouse. Ensure 
    this form is fully completed which includes the completion by the legal official.</p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `14.5%`,
        data: `<p><strong>Contract Number:</strong> Enter the number that matches 
        the associated Purchase Contract Number.</p>`,
      },
      {
        x: `1.5%`,
        y: `17.5%`,
        data: `<p><strong>Municipal Address:</strong> Enter the municipal address 
        of the property that this consent applies to.</p>`,
      },
      {
        x: `1.5%`,
        y: `21%`,
        data: `<p><strong>When to use this form:</strong> Use this form when there 
        is only one person on the property title and that person is legally 
        married (check the Land Title Document to confirm). It applies if either 
        the owner or their spouse has lived in the home during the marriage, 
        even if they are now separated and not divorced. This form is not used 
        for common-law relationships.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Other forms to sign:</strong> Refer to this list to keep 
        track of any forms that the non-owner spouse will be required to sign 
        throughout the sale process.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `38%`,
        data: `<p>As per the first point, this consent form is not required  if 
        there is already a Release of Dower Rights registered on the property's title. 
        However, since that release can be canceled under the Dower Act, it's a good 
        idea to get legal advice if a Release of Dower Rights is on the title, just 
        to be safe and clear on the situation.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `50%`,
        data: `<p><strong>Consent of Spouse:</strong>  Complete this section using the 
        example provided. This is where the non-owner spouse will sign the form and 
        consent to the sale of the property.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Certificate of Acknowledgement:</strong> This part confirms 
        that the non-owner spouse met with a legal official alone, without their 
        husband or wife present, and they confirmed a few important things:
        <ol class="letter-ol">
          <li>They understand what the sale or agreement is about.</li>
          <li>They know the Dower Act gives them certain rights, like the right to 
          live in the property for life and the right to stop the sale.</li>
          <li>They are agreeing to give up those rights so the sale or agreement can 
          go ahead.</li>
          <li>They are signing willingly, without being pressured by their spouse.</li> 
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `80%`,
        data: `<p> This portion will be completed by the legal official. It will 
        typically include a stamp and signature in order to confirm its completion.
        </p>`,
      },
    ],
  },
  {
    id: 1151,
    form: `realtor-disclosure-to-rep-party`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/disclosures/realtor-disclosure-to-rep-party-1.png",
    description: `<p>This form is used to inform a represented person (whether Buyer 
    or Seller) that the REALTOR® has some form of either direct or indirect financial 
    interest in the transaction and/or a conflict of interest. It ensures full 
    transparency and disclosure of potential conflicts of interest, making the party 
    aware of the REALTOR®'s role. This form is essential for upholding ethical 
    standards, making sure all parties are informed about what must be disclosed.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can be 
        your own personal identifier for this document.  
        </p>`,
      },
      {
        x: `1.5%`,
        y: `16%`,
        data: `<p><strong>Property:</strong> Complete this section by filling in all 
        the property details for which this disclosure/transaction applies. </p>`,
      },
      {
        x: `1.5%`,
        y: `21%`,
        data: `<p><strong>REALTOR®'s Financial Interest (Section 1):</strong> 
        <ol class="letter-ol">
        <li>Complete this section by filling in all of the required details as 
        shown in the example.</li>
        <li>Provide the type of financial interest whether it is direct or indirect.
        An example of indirect interest would be if you are representing a relative 
        in the transaction. Direct interest would involve you being the client.</li>
        <li>Complete the statement with "does" or "does not" with respect to whether 
        or not the client being disclosed to is represented by your Brokerage.</li>
        <li>As per this statement, this is a declaration that the property may be 
        rented or sold and profit may be made.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `47%`,
        data: `<p><strong>Conflict of Interest (Section 2): </strong> 
        In this section, complete the statements that apply to the nature of the 
        conflict of interest.
        <ol class="letter-ol">
        <li>This would be completed if the client and another party are represented 
        by the Brokerage.</li>
        <li>Detail the nature of the relationship that the party has with the 
        Brokerage.</li>
        <li>If the Brokerage has confidential information about the party being 
        disclosed to, based on the relationship, complete this section.</li>
        <li>As per this statement, this is a declaration that the property may be 
        rented or sold and profit may be made.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Due Diligence (Section 3): </strong> 
        Complete this section by inserting the signature of the REALTOR® that is making 
        the disclosure.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `75%`,
        data: `<p><strong>Acknowledgement: </strong> 
        As per the statement, this disclosure needs to occur before the presentation 
        of a purchase contract.  
        </p>`,
      },
      {
        x: `1.5%`,
        y: `81%`,
        data: `<p><strong>Signatures: </strong> 
        This portion must be signed by the individual(s) receiving the disclosure. 
        Enter the date and time of signing, and ensure the correct party (Buyer or 
        Seller) includes both their signature and printed name.
        </p>`,
      },
    ],
  },
  {
    id: 1161,
    form: `realtor-disclosure-to-unrep-party`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/disclosures/realtor-disclosure-to-unrep-party-1.png",
    description: `<p>This form is used to inform a unrepresented person (whether Buyer 
    or Seller) that the REALTOR® has some form of either direct or indirect financial 
    interest in the transaction and/or a conflict of interest. It ensures full 
    transparency and disclosure of potential conflicts of interest, making the party 
    aware of the REALTOR®'s role and information that is to be disclosed. This form 
    is essential for upholding ethical standards, making sure all parties are informed 
    about what must be disclosed.</p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can be 
        your own personal identifier for this document.  
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Property:</strong> Complete this section by filling in all 
        the property details for which this disclosure/transaction applies. </p>`,
      },
      {
        x: `1.5%`,
        y: `21%`,
        data: `<p><strong>REALTOR® Disclosure (Section 1):</strong> 
        <ol class="letter-ol">
        <li>Complete this section by filling in all of the required details as 
        shown in the example.</li>
        <li>Provide the type of financial interest whether it is direct or indirect.
        An example of indirect interest would be if you are representing a relative 
        in the transaction. Direct interest would involve you being the client.</li>
        <li>complete.</li>
        <li>If the REALTOR® making the disclosure is aware of any information that 
        could materially affect the value of the real estate, do so here. Example: 
        An Agent's knowledge of a factory or condo building being built behind the 
        transaction property could affect the value of the property and the 
        knowledge of this should be disclosed.</li>
        <li>As per this statement, this is a declaration that the property may be 
        rented or sold and profit may be made.</li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `67%`,
        data: `<p><strong>Due Diligence (Section 3): </strong> 
        As per the statement, the individual being disclosed to is not represented 
        by a Brokerage and has had the opportunity to seek legal advice. Complete 
        this section by inserting the signature of the REALTOR® that is making 
        the disclosure.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `75%`,
        data: `<p><strong>Acknowledgement: </strong> 
        As per the statement, this disclosure needs to occur before the presentation 
        of a purchase contract.  
        </p>`,
      },
      {
        x: `1.5%`,
        y: `81%`,
        data: `<p><strong>Signatures: </strong> 
        This portion must be signed by the individual(s) receiving the disclosure. 
        Enter the date and time of signing, and ensure the correct party (Buyer or 
        Seller) includes both their signature and printed name.
        </p>`,
      },
    ],
  },
  {
    id: 1171,
    form: `realtor-cooperation-policy`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/disclosures/realtor-cooperation-policy-1.png",
    description: `<p>The purpose of the CREA REALTOR® Cooperation Disclosure and 
    Consent Form is to: Inform sellers about the benefits of listing their property 
    on an MLS® System, which includes increased exposure and the potential for more 
    favorable offers. Explain the meaning of public marketing, and how it triggers 
    the requirement to list the property on an MLS® within three days. Provide sellers 
    with the option to opt out of public marketing and MLS® exposure, while ensuring 
    they understand the potential downsides, like fewer buyers and lower offers. 
    Document the seller's informed consent if they choose to decline public marketing 
    and MLS® listing, in compliance with the REALTOR® Code of Ethics. You can read 
    more about the exemptions & FAQs surrounding this policy at the following link: 
    <a href="https://www.crea.ca/REALTORCooperation" target="_blank" rel="noopener noreferrer">CREA Cooperation Policy</a>.</p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `9%`,
        data: `<p><strong>Disclosure of Cooperation Policy: </strong> This section 
        involves disclosure to the Seller that REALTORS® must list a property on an 
        MLS® System within three days of any public marketing, as required by their 
        Code of Ethics, unless an exemption applies. Public marketing includes 
        things like flyers, yard signs, social media, and online ads, but not 
        private one-on-one communications with other REALTORS®. MLS® listings help 
        sellers by increasing exposure and potentially attracting better offers. 
        However, sellers can opt out of MLS® listings if they choose not to market 
        the property publicly and complete a consent form.</p>`,
      },
      {
        x: `1.5%`,
        y: `43.5%`,
        data: `<p><strong>Consent: </strong> Furthermore, if the Seller chooses 
        not to publicly market the property or list it on an MLS® System, they 
        understand this could lead to less exposure, fewer offers, and possibly 
        less favorable sale terms. By signing, the Seller confirms this choice 
        and instructs their REALTOR® not to market the property publicly. However, 
        if public marketing begins later, the property must be added to the MLS® 
        System within three days, unless an exemption applies.</p>`,
      },
      {
        x: `1.5%`,
        y: `74%`,
        data: `<p><strong>Signature: </strong> Have the Seller(s) sign, with 
        printed name, and date to formalize their understanding and consent to 
        proceeding with the sale of the property without public marketing.</p>`,
      },
    ],
  },
  {
    id: 1181,
    form: `fee-disclosure`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/disclosures/fee-disclosure-1.png",
    description: `<p>The purpose of this document is to ensure transparency to the 
    client with respect to the fee being received. Fees must be disclosed to the 
    client by the licensee who will be receiving the fee. This typically involves, 
    but not limited to, real estate referrals which can involve REALTORS® connecting 
    their clients with other industry professionals or services they may need, such 
    as mortgage brokers, property managers, or even other REALTORS® with expertise 
    in different areas. It is important to note that all fees must be processed through 
    the Brokerage.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number is to be 
        completed on all pages and can be your own personal identifier for this 
        specific document.</p>`,
      },
      {
        x: `1.5%`,
        y: `12.5%`,
        data: `<p><strong>Brokerage Name:</strong> Enter the name of the Brokerage 
        providing this disclosure.</p>`,
      },
      {
        x: `1.5%`,
        y: `16%`,
        data: `<p><strong>Client Name:</strong> Enter the name of the Clients 
        who are receiving this disclosure.</p>`,
      },
      {
        x: `1.5%`,
        y: `24%`,
        data: `<p><strong>Fee Disclosure: </strong> Enter the amount of the fee 
        that is being received for the services provided. It is important to be 
        as detailed as possible. Example: 25% of the Buyer/Cooperating Commission 
        on a purchase transaction.</p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Address of Property: </strong> Insert the Address or Legal 
        Description of the property to which the fee disclosure applies.</p>`,
      },
      {
        x: `1.5%`,
        y: `33.5%`,
        data: `<p><strong>Who is Paying the Fee: </strong> Insert who will be 
        paying the fee here. This could be another brokerage for the referral of a 
        client or a 3rd party service provider like a mortgage broker.</p>`,
      },
      {
        x: `1.5%`,
        y: `43%`,
        data: `<p><strong>Signatures: </strong> Insert the date along with the 
        Agent's signature and printed name (agent making the disclosure/receiving a 
        fee).</p>`,
      },
      {
        x: `1.5%`,
        y: `52%`,
        data: `<p><strong>Acknowledgement Client received a copy of this Disclosure: 
        </strong> Have the client initial this section to acknowledge they have 
        received a copy of the disclosure. Insert the date when this disclosure was 
        provided to the client.</p>`,
      },
    ],
  },
  {
    id: 1191,
    form: `notice-satisfy-conditions`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/notices/notice-satisfy-conditions-1.png",
    description: `<p>This form is used to formally notify the other party 
    in a purchase contract that the buyer (or seller, depending on the 
    conditions) is either: Waiving a condition — choosing not to require 
    that condition to be fulfilled; or Satisfying a condition — confirming 
    that the condition has been met.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `11%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number can 
        be your own personal identifier. For this document, the number here 
        must match the Contract Number of the associated Purchase Contract.
        </p>`,
      },

      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyer/Seller Names:</strong> Insert the names 
        of all the Buyers and Sellers here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `19.5%`,
        data: `<p><strong>Municipal Address:</strong> Enter the full municipal 
        address of the property, matching the associated Purchase Contract.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Buyer or Seller: </strong>Insert the party that is 
        waiving or satisfying the condition.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `31%`,
        data: `<p><strong>Condition: </strong> Insert the condition(s) that are 
        being waived or satisfied. It is best practice to insert the condition 
        as it appears in the Purchase Contract or latest amendment. Ensure you 
        are specific about the condition(s) and do not put general statements 
        like "all conditions".
        </p>`,
      },
      {
        x: `1.5%`,
        y: `64%`,
        data: `<p><strong>Signatures/Date:</strong> Have all parties to the 
        contract sign, along with the location/date, to finalize the notice 
        form. The signing of this notice and communication must occur before 
        expiry of the stated conditions in this notice. 
        </p>`,
      },
    ],
  },
  {
    id: 1201,
    form: `notice-non-satisfy-conditions`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/notices/notice-non-satisfy-conditions-1.png",
    description: `<p>This form is used to formally notify the other party 
    in a purchase contract that the buyer (or seller, depending on the 
    conditions) is not waiving or satisfying the condition(s).
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `11%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number can 
        be your own personal identifier. For this document, the number here 
        must match the Contract Number of the associated Purchase Contract.
        </p>`,
      },

      {
        x: `1.5%`,
        y: `15%`,
        data: `<p><strong>Buyer/Seller Names:</strong> Insert the names 
        of all the Buyers and Sellers here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `19.5%`,
        data: `<p><strong>Municipal Address:</strong> Enter the full municipal 
        address of the property, matching the associated Purchase Contract.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>Buyer or Seller: </strong>Insert the party that is 
        choosing not to waive or satisfy the condition(s).
        </p>`,
      },
      {
        x: `1.5%`,
        y: `31%`,
        data: `<p><strong>Condition: </strong> Insert the condition(s) that are 
        not being waived or satisfied. It is best practice to insert the condition 
        as it appears in the Purchase Contract or latest amendment. Ensure you 
        are specific about the condition(s) and do not put general statements 
        like "all conditions".
        </p>`,
      },
      {
        x: `1.5%`,
        y: `64%`,
        data: `<p><strong>Signatures/Date:</strong> Have all parties to the 
        contract sign, along with the location/date/time, to finalize the notice 
        form. This form must be signed and communicated to the other party to 
        confirm that the condition(s) have not been met or waived.
        </p>`,
      },
    ],
  },
  {
    id: 1211,
    form: `EBRA-termination`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-termination-1.png",
    description: `<p>The purpose of this document is to formally end the 
    contractual relationship between a Real Estate Brokerage and a Buyer before 
    the original expiry date of the Agreement.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can 
        be your own personal identifier. For this document, the number here 
        must match the Agreement Number of the associated EBRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Brokerage/Sellers:</strong> Insert the Brokerage(s) and
        Buyers names here as indicated in the EBRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>EBRA Reference Number:</strong> Insert the EBRA Agreement 
        Number here so that it is clear which EBRA is being terminated. You can 
        find this number on the top right of the EBRA, as with most agreements.
        <br/><br/>
        <strong>Effective Date:</strong> Add in the date for when this 
        termination will take effect. 
        </p>`,
      },

      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Termination Type: </strong>This section has 2 options 
        for termination, select the one that applies.
        <br/><br/>
        <ol>
        <li><strong>Unconditional Termination:</strong> Use this checkbox when 
        the termination is final as of the termination date, and all parties 
        are released from any further duties owed under the original agreement.
       </li>
       <li><strong>Conditional Termination:</strong> Use this section when both 
       parties have agreed to end the agreement, but some obligations—such as a 
       holdover clause or reimbursement of costs—still apply. Refer to Section 8 
       of the EBRA for a detailed list of any remaining responsibilities. If 
       there are any new, mutually agreed-upon terms not currently included in 
       the EBRA that should apply to the termination, make sure to check the 
       "additional terms" box and insert the details of the new terms here.
       </li>
        </ol>
        
        </p>`,
      },

      {
        x: `1.5%`,
        y: `50%`,
        data: `<p><strong>Date/Signatures:</strong> Have all Buyers sign here and 
        insert the date when the termination was signed.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `66%`,
        data: `<p><strong>Agent Signature:</strong> Insert Agent Signature and 
        Printed Name here.
        </p>`,
      },
    ],
  },
  {
    id: 1221,
    form: `ESRA-termination`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-termination-1.png",
    description: `<p> The purpose of this document is to formally end the 
    contractual relationship between a Real Estate Brokerage and a Seller before 
    the original expiry date of the Agreement.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can 
        be your own personal identifier. For this document, the number here 
        must match the Agreement Number of the associated ESRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Brokerage/Sellers:</strong> Insert the Brokerage(s) and
        Sellers names here as indicated in the ESRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>MLS Number:</strong> If there is an MLS® Number associated 
        with this listing, insert it here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p><strong>ESRA Reference Number (1.1):</strong> Insert the ESRA 
        Agreement Number here so that it is clear which ESRA is being terminated. 
        You can find this number on the top right of the ESRA, as with most 
        agreements. Additionally, insert the address of the property here.
        </p>`,
      },

      {
        x: `1.5%`,
        y: `33%`,
        data: `<p><strong>Effective Date of Termination:</strong> Insert the 
        date when this termination will take effect. As per the statement, the 
        effective date of termination will be the either the date noted here or 
        when this document is fully signed, whichever is later.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `36%`,
        data: `<p><strong>Termination Type: </strong>This section has 2 options 
        for termination, select the one that applies.
        <br/><br/>
        <ol>
        <li><strong>Unconditional Termination:</strong> Check this box if the 
        termination is to not include any other additional terms. Essentially, this 
        circumstance releases all parties from the ESRA with no further 
        obligations.
       </li>
       <li><strong>Conditional Termination:</strong> Use this section when both 
       parties have agreed to end the agreement, but some obligations—such as a 
       holdover clause or reimbursement of costs—still apply. Refer to Section 9 
       of the ESRA for a detailed list of any remaining responsibilities. If 
       there are any new, mutually agreed-upon terms not currently included in 
       the ESRA that should apply to the termination, make sure to check the 
       "additional terms" box and insert the details of the new terms here.
       </li>
        </ol>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `62%`,
        data: `<p><strong>Date/Signatures:</strong> Have all Sellers sign here and 
        insert the date when the termination was signed.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `73%`,
        data: `<p><strong>Broker Signature:</strong> Have your Broker sign here 
        to finalize the termination. Additionally, insert the printed name of the 
        Broker here.  Refer to the <a href="https://exptransactionguide.com/YT/office-procedures" rel="noopener noreferrer" >
        Office Procedures</a> Section to find out how to process these documents 
        for Broker Signature.</p>`,
      },
    ],
  },
  {
    id: 1231,
    form: `ESRA-amendment`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/ESRA/ESRA-amendment-1.png",
    description: `<p>The purpose of this document is to formally modify the terms 
    of an existing ESRA after it has been signed by all parties. 
    An amendment allows changes to be made while keeping the original Agreement 
    in force. It is important to note that once the ESRA has been 
    accepted by all parties, any further changes must be made through an Amendment.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can 
        be your own personal identifier. For this document, the number here 
        must match the Agreement Number of the associated ESRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Brokerage/Sellers:</strong> Insert the Brokerage(s) and
        Sellers names here as indicated in the ESRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `22%`,
        data: `<p><strong>MLS Number:</strong> If there is an MLS® Number associated 
        with this listing, insert it here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `26%`,
        data: `<p><strong>ESRA Reference Number:</strong> Insert the ESRA Agreement 
        Number here so that it is clear which ESRA is being amended. You can find 
        this number on the top right of the ESRA, as with most agreements.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Address:</strong> Insert the address of the property here. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `29%`,
        data: `<p><strong>Address/Effective Date:</strong> Insert the full address 
        of the property to which this amendment applies. Add in the date for when this 
        amendment will take effect. 
        </p>`,
      },
      {
        x: `1.5%`,
        y: `34%`,
        data: `<p><strong>Amendments: </strong> This section is where you will 
        notate the applicable amendments to the ESRA. #1 and #2 are the most common 
        amendments and as such, they have pre-printed text already set for these 
        circumstances.  If the first 2 do not apply, you can add any other 
        amendments in #3. If the amendment involves an insertion as well as a 
        deletion, you can use a similar format to the purchase contract amendment.
        <br/><br/>Example:<br/> 
        <br/><strong>DELETE:</strong><br/>Possession Date: 30 days<br/>
        <br/><strong>INSERT:</strong><br/>Possession Date: 60 days<br/>
        </p>`,
      },
      {
        x: `1.5%`,
        y: `58%`,
        data: `<p>As per this statement, all other terms of the ESRA remain the 
        same.  This is a simple way to confirm that the amendment is only 
        affecting the terms that have been amended.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Date/Signatures:</strong> Have all Sellers sign here and 
        insert the date when the amendment was signed.
        </p>`,
      },
    ],
  },
  {
    id: 1241,
    form: `EBRA-amendment`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/EBRA/EBRA-amendment-1.png",
    description: `<p>The purpose of this document is to formally modify the terms 
    of an existing EBRA after it has been signed by all parties. 
    An amendment allows changes to be made while keeping the original Agreement 
    in force. It is important to note that once the EBRA has been 
    accepted by all parties, any further changes must be made through an Amendment.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number can 
        be your own personal identifier. For this document, the number here 
        must match the Agreement Number of the associated EBRA.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `18%`,
        data: `<p><strong>Brokerage/Buyers:</strong> Insert the Brokerage(s) and
        Buyers names here as indicated in the EBRA.
        </p>`,
      },

      {
        x: `1.5%`,
        y: `24%`,
        data: `<p><strong>EBRA Reference Number:</strong> Insert the EBRA Agreement 
        Number here so that it is clear which EBRA is being amended. You can find 
        this number on the top right of the EBRA, as with most agreements.
        <br/><br/>
        <strong>Effective Date:</strong> Add in the date for when this 
        amendment will take effect. 
        </p>`,
      },

      {
        x: `1.5%`,
        y: `28%`,
        data: `<p><strong>Amendments: </strong> This section is where you will 
        notate the applicable amendments to the EBRA. #1 and #2 are the most common 
        amendments and as such, they have pre-printed text already set for these 
        circumstances.  If the first 2 do not apply, you can add any other 
        amendments in #3. If the amendment involves an insertion as well as a 
        deletion, you can use a similar format to the purchase contract amendment.
       
        </p>`,
      },
      {
        x: `1.5%`,
        y: `58%`,
        data: `<p>As per this statement, all other terms of the EBRA remain the 
        same.  This is a simple way to confirm that the amendment is only 
        affecting the terms that have been amended.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `63%`,
        data: `<p><strong>Date/Signatures:</strong> Have all Buyers sign here and 
        insert the date when the amendment was signed.
        </p>`,
      },
    ],
  },
  {
    id: 1251,
    form: `amendment-purchase-contract`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/amendments/amendment-purchase-contract-1.png",
    description: `<p>The purpose of this document is to formally modify the terms 
    of an existing Purchase Contract after it has been signed by all parties. 
    An Amendment allows changes to be made while keeping the original Agreement 
    in force. It is important to note that once a Purchase Contract has been 
    accepted by all parties, any further changes must be made through an Amendment.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `11%`,
        data: `<p><strong>Purchase Contract Number:</strong> This number 
        relates to the Purchase Contract that is being amended.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `15.5%`,
        data: `<p><strong>Buyers/Sellers Names & Municipal Address:</strong> Insert 
        all Buyers and Sellers names here as indicated in the Purchase Contract. 
        Additionally, insert the Municipal Address of the property here.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `25%`,
        data: `<p><strong>Delete/Insert:</strong> Start this form by deleting 
        and/or inserting the items in the Purchase Contract which are being amended. 
        (example:  Purchase Price: $500,000). Then 
        Insert the item that is being amended (example: Purchase Price: $475,000). See
        the example below. Also, if you are adjusting something like a condition 
        that is already in the Purchase Contract, you cannot just "Insert" the 
        new condtion.  The condtion that is already in the Purchase Contract would 
        need to be deleted in order to avoid having 2 of the same conditions in the
        Contract.<br/>
        <br/><strong>Delete:</strong><br/>Purchase Price: $500,000<br/>
        <br/><strong>Insert:</strong><br/>Purchase Price: $475,000<br/></p>`,
      },
      {
        x: `1.5%`,
        y: `65%`,
        data: `<p><strong>Signatures:</strong> All parties involved in the Contract 
        should sign here to confirm their agreement and acknowledgment of the 
        changes being made to the Purchase Contract. If this amendment involves 
        the modification of a current condition, this section should be fully 
        signed by all parties before the expiry of the condition.`,
      },
    ],
  },
  {
    id: 1261,
    form: `referral-fee-consent`,
    page: `1`,
    imageURL: "../../images/Yukon/forms/referral/referral-fee-consent-1.png",
    description: `<p>This form is used to obtain consent from your client in order 
    to refer them out to either another agent or 3rd party, and receive a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1.5%`,
        y: `4%`,
        data: `<p><strong>Agreement Number:</strong> The Agreement Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1.5%`,
        y: `12.5%`,
        data: `<p><strong>Brokerage:</strong> Insert the name of the Brokerage 
        that will be receiving the referral fee. This is will be same as the 
        Brokerage that is referring out the client.
        </p>`,
      },
      {
        x: `1.5%`,
        y: `17%`,
        data: `<p><strong>Referral Type:</strong> Check the box that applies to 
        type of referral to which the referral fee is being paid. Complete the 
        "other" section if the referral type is not listed.`,
      },
      {
        x: `1.5%`,
        y: `27%`,
        data: `<p>Complete this section to identify the who is making 
        the referral and who is receiving it. 
        <br/><br/>
        <strong>Client Referred From:</strong> Complete this section providing 
        all available information to identify who is referring the 
        client out to another party.
        <br/><br/>
        <strong>Client Referred To:</strong> Complete this section providing 
        all available information to identify who is receiving the client in 
        order to provide the stated services. If this is an Agent to Agent 
        referral, this will be the Brokerage/Agent who receives the client and 
        will be providing services to the client (likely sell their home or 
        find a property to purchase, or both). If the referral is for the 
        purposes of receiving a referral for a 3rd party service (example: a 
        mortgage approval, complete this section with their details).`,
      },
      {
        x: `1.5%`,
        y: `45%`,
        data: `<p><strong>Client Information:</strong> Insert all the details of 
        the client that is being referred.`,
      },
      {
        x: `1.5%`,
        y: `57%`,
        data: `<p><strong>Additional Client Information:</strong> Insert any 
        details that are important to the referral, such as what they are looking 
        for or any other information that is relevant to the referral.`,
      },
      {
        x: `1.5%`,
        y: `74%`,
        data: `<p><strong>Date/Signatures:</strong> Insert the date of when this 
        referral is taking place and have all clients that are being referred 
        sign here.`,
      },
    ],
  },
  /* Agricultural Forms */
  {
    id: 1271,
    form: `agri-purchase-contract`,
    page: `1`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-1.png",
    description: `<p><strong>You must have a Rural License to use this form.</strong> <br/>
    This Form is to be used for Agricultural properties where the property or 
    land generates Income or is zoned and used for agricultural purposes.  It 
    should not be used for a country residential property that is a country 
    residential acreage. The difference is critical. If the land is currently 
    generating income through agricultural activities, crop leases, natural 
    resource usage, this Agricultural Purchase Contract is used.

    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Buyers & Sellers:</strong> Ensure that you input the complete legal names of both Buyers and 
        Sellers. Take the extra step of cross-referencing your clients' IDs to 
        guarantee accuracy. If the client is a corporation, be sure to obtain 
        documents, such as the Articles of Incorporation, to confirm signing authority. 
        Verify the Seller names in the Land Title document; refrain 
        from simply copying them from the listing as discrepancies in names may 
        exist. 
        </p>`,
      },
      {
        x: `1%`,
        y: `24%`,
        data: `<p><strong>The Property:</strong> As noted in this section, add 
        in the County or Municipal District followed by the Municipal Address. 
        In the following table, insert all the details of the property as they 
        are shown in the Land Title Document. This will clearly define what is 
        being purchased. If there are multiple titles surrounding the purchase, 
        insert the details of each title.
        </p>`,
      },
      {
        x: `1%`,
        y: `47%`,
        data: `<p><strong>Mines & Minerals:</strong> If the Land Title document 
        refers to exceptions surrounding mines or minerals rights, insert those 
        details here. When you buy the land, you're buying the surface rights 
        (the right to farm, build, etc.), but not necessarily the rights to the 
        valuable resources underground — unless the contract explicitly includes 
        them. If this situation arises, have your client consult their lawyer 
        to confirm if any 3rd party rights exist and how they might affect the 
        use of the land.
        </p>`,
      },
      {
        x: `1%`,
        y: `51%`,

        data: `<p><strong>Unattached Goods:</strong> These are items that are to be included
        in the purchase price and typically involve items not fixed to the property. 
        Chattels are movable items such as: appliances, garage door remotes, mirrors
        not fixed to the walls...etc. It is important to be as detailed as possible
        when describing the chattels to be included. Some items such as fixed tv mounts
        have been greatly debated as to whether they need to be included in the 
        unattached goods section. 
        As a rule of thumb, "if in doubt, include it" so that it is clear to all 
        parties.</p>`,
      },
      {
        x: `1%`,
        y: `54%`,

        data: `<p><strong>Attached Goods Excluded:</strong> These are items that are
        attached to the home but the Seller wishes to exclude them from the sale. 
        One reason may be that the item listed has sentimental value like a lighting 
        fixture. Precision is key when itemizing excluded fixtures, for instance, 
        specifying "bedroom light fixture."</p>`,
      },
      {
        x: `1%`,
        y: `58.5%`,

        data: `<p><strong>Accepted Tenancies:</strong> </p>`,
      },
      {
        x: `1%`,
        y: `64%`,
        data: `<p><strong>Purchase Price:</strong> This is the price the Buyer is 
        offering for the property. As stated on this agreement, this price 
        does not include GST. You should always refer the client to an 
        accountant or lawyer by way of an accountant/lawyer review 
        clause in the contract if your client has any questions regarding 
        GST.  
        </p>`,
      },
      {
        x: `1%`,
        y: `67%`,
        data: `<p><strong>GST Payable (2.2): </strong> This clause outlines how GST 
        is to be handled, depending on whether the buyer is a GST registrant or not. 
        In short, if the Buyer is NOT A GST registrant, they will be responsible for 
        paying the GST to the seller's lawyer by the closing date and the Seller will 
        remit that GST to the government. If the Buyer IS A GST registrant, the 
        Buyer must give the Seller proof of their GST registration before the closing 
        date. In this situation, the Buyer is responsible for paying the GST directly 
        to the government. In both scenarios, the party obligated to pay the GST will 
        also be liable for any costs the other party incurs if they fail to fulfill 
        that obligation.
        </p>`,
      },
      {
        x: `1%`,
        y: `81%`,
        data: `<p><strong>Completion Date:</strong> This is the proposed date of 
        closing (the date your clients would like to take ownership of the property). 
        Ensure that the date placed here is not a weekend or holiday. Additionally, 
        insert dates with respect to when harvested crops will be removed by. Also 
        indicate the date to which any unharvested crops will not be removed and 
        become the property of the Buyer.<br/><br/>As per 2.4,
        the Seller also represents & warrants that they will not make any changes to 
        any existing leases without the Buyer's consent, in writing.</p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1272,
    form: `agri-purchase-contract`,
    page: `2`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-2.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `7%`,
        data: `<p><strong>2.5:</strong> the Seller also represents & warrants that the 
        property will be in the same condition as when this contract is accepted as 
        well as all the included attached/unattached goods.
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Section 3:</strong> Understanding all the General 
        Terms included in this contract is essential. This section establishes a 
        standard set of legal and practical terms that guide how the Buyer and Seller 
        must behave and what rules govern the real estate transaction. If your client 
        has any questions, you should be prepared to explain each element clearly 
        and professionally. </p>`,
      },
      {
        x: `1%`,
        y: `53%`,
        data: `<p>This section outlines which Brokerage is responsible for 
        delivering the contract and related documents to the lawyers 
        involved in the transaction. While this is usually done by the 
        Seller's Brokerage, either the Buyer's or Seller's Brokerage may 
        take on this responsibility. Be sure to specify which one applies.</p>`,
      },
      {
        x: `1%`,
        y: `58%`,
        data: `<p><strong>Deposits:</strong> This section explains the terms 
        related to how the deposit will be delivered. It’s recommended to 
        check with the listing agent or lawyer in advance to confirm what 
        payment methods are accepted by their Brokerage or office before 
        filling out this section. <br/>
        <strong>4.2: </strong>Insert who will hold the deposit (in trust). Typically 
        the listing Brokerage holds the deposit but it can be either a Brokerage or 
        lawyer if the parties agree otherwise.<br/>
        <strong>4.3: </strong>Enter the amount of deposit that will be provided, 
        method of payment, and when the deposit is due. Typically this may be via e-transfer or bank 
        draft but it is important to discuss methods of payment that are acceptable 
        with the party that will be holding the deposit.<br/>
        <strong>4.4: </strong>If an additional deposit is to be made as part of this 
        contract, complete this section similar to section 4.3. If no additional 
        deposit is to be made, this can be left blank.<br/>
        <strong>4.5-4.9: </strong>Understanding these additional Deposit 
        Terms included in this contract is essential. If your client has 
        any questions, you should be prepared to explain each element 
        clearly and professionally.</p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1273,
    form: `agri-purchase-contract`,
    page: `3`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-3.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Land Title: </strong>Understanding these additional 
        Terms relating to Land Title is essential. Simply put, When the 
        property is sold, the ownership title must be clear of any financial 
        claims or legal issues, except for a few specific types that are 
        considered normal or agreed to. <br/>
        The Seller promises to give the Buyer clear ownership of the 
        property. That means no mortgages, unpaid taxes, or legal claims that 
        could affect the Buyer's ownership—unless listed below.
        <ol class="letter-ol">
        <li>These are rights or restrictions that apply automatically under 
        Yukon law, even if they're not written on the title. Example: a legal 
        right of access for emergency services.</li>
        <li>These are common, non-money-related things already registered on 
        the property that are normal for this type of property, and the Buyer 
        is expected to accept. Example: easements, rights-of-way, restrictive 
        covenants..etc.</li>
        <li>Anything the Buyer has agreed to accept in the contract.</li>
        </ol>
        <br/>
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Representations and Warranties: </strong>In this 
        section, the Seller makes several important promises (representations and 
        warranties) to the Buyer, which are like guarantees about the property. 6.2 
        includes that the Buyer states that they are eligible to purchase "controlled 
        land" as defined in the Foreign Ownership of Land Regulations. <br/><br/>
        As per 6.3, it is important to note that these representations and warranties 
        go beyond the closing of the transaction, with restrictions. 
        <br/>
        <strong>Example: </strong>Imagine the sale is complete, but the Seller fails 
        to follow through on a repair they agreed to make (e.g., a repair). The Buyer 
        can still take legal action to make sure it's fixed, but only if they start 
        that action within the time allowed by law (usually a few years).
        </p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1274,
    form: `agri-purchase-contract`,
    page: `4`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-4.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Dower: </strong> The Seller is confirming that 
        their spouse does not have any claim (dower rights) to the property. 
        If they do and Dower Rights apply, complete this 
        section by inserting a date that specifies when the Dower Consent Form 
        is due.  Best practices would be to have this form within a couple of 
        weeks of the acceptance of the contract. The Seller must get their 
        spouse to sign the contract 
        and provide a Dower Consent form by the specified date. If the Seller 
        fails to do this, the Buyer can cancel the contract, but only if 
        they do so before the Seller provides the form (even if it's late).
        </p>`,
      },
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Conditions (8.1):</strong> This section outlines the 
        conditions that are included as part of the contract. The Buyer and 
        Seller promise to act fairly, do their part to meet their conditions, 
        and cover any costs that come with meeting those conditions. </p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Conditions (8.2):</strong> In this section, fill in 
        the details for any conditions the Buyer wishes to include in the 
        contract. As professional REALTORS®, it's important to clearly 
        explain the potential risks and benefits of each condition to 
        help your client make an informed decision about whether or not 
        to include them. “Time is of the essence” when it comes to all elements 
        of the contract, especially conditions. Make sure that contracts and 
        related deal documents are signed within their designated time 
        frames to best protect your clients. Any 
        pre-printed conditions in this section that are left incomplete 
        will not form part of the contract.
        <br/>In accordance 8.4 (below), 
        failure to waive or satisfy the conditions within the specified 
        timeframe will result in the contract being terminated, provided the 
        correct notice is delivered.</p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1275,
    form: `agri-purchase-contract`,
    page: `5`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-5.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>Additional Buyer's Conditions:</strong> Insert any 
        additional Buyer's conditions in this section that will form part of 
        the contract. If the condition is not in the Clause Booklet or an eXp 
        approved condition, have your clients lawyer draw up the custom 
        condition to best protect your client(s). At the bottom, insert a date when these conditions are due 
        to be satisfied. 
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Additional Seller's Conditions:</strong> The Seller 
        will insert any conditions in this section that they will to form part 
        of the contract. If you represent the Seller and the condition is not 
        in the Clause Booklet or an eXp approved condition, have your clients 
        lawyer draw up the custom condition to best protect your client(s). At 
        the bottom, insert a date when these conditions are due to be satisfied. 
        </p>`,
      },
      {
        x: `1%`,
        y: `65%`,
        data: `<p><strong>Attachments and Additional Terms:</strong> Select 
        the checkboxes for any documents that are attached to this contract 
        and considered part of the contract. If none appy, this can be left 
        blank.
        </p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1276,
    form: `agri-purchase-contract`,
    page: `6`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-6.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Other Terms:</strong> Enter any additional terms 
        that will be included as part of the contract. If the term is not in 
        the Clause Booklet or an eXp approved term, have your clients lawyer 
        draw up the custom term to best protect your client(s). It is important 
        to note that terms typically cannot stop a contract from proceeding. Their 
        presence is more to provide a guide for the parties to follow. 
        </p>`,
      },
      {
        x: `1%`,
        y: `34%`,
        data: `<p><strong>Closing Process:</strong> Understanding the Closing 
        Process and being able to explain to your client clearly and 
        professionally is paramount to doing your part in ensuring a smooth 
        closing. Make sure you understand this section of the contract so you can 
        confidently explain the process to your client.
        </p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1277,
    form: `agri-purchase-contract`,
    page: `7`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-7.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Insurance:</strong> In short, If the property gets damaged 
        before the Buyer has paid in full, the Seller is responsible for it, 
        and any insurance money will be held for both the Seller and Buyer, 
        depending on what they're owed. </p>`,
      },
      {
        x: `1%`,
        y: `31%`,
        data: `<p><strong>Remedies:</strong> If one party fails to complete the 
        contract, it's important to understand the potential consequences 
        of that action. Have your client fully understand the seriousness of 
        entering into a legally binding contract.  If one party does not 
        complete the deal, advise your client to consult their lawyer to 
        ensure the situation is handled appropriately.</p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Notices and Documents:</strong> Ensure you are familiar 
        with the process of serving notices and documents. “Time is of the 
        essence” when it comes to all elements of the contract, especially 
        when serving time sensitive documents. Make sure that notices and 
        documents are signed and delivered 
        within their designated time frames to best protect your clients.</p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Authorization:</strong> Complete this section by entering the names of both the 
        Seller's and Buyer's Brokerages, along with the agents involved in the 
        transaction. If one party does 
        not have a REALTOR® or Brokerage, this section should either be left 
        blank or read "Self Represented" in the section that applies. 
        Additionally, see section 14.2 below when dealing with a situation in 
        which one party is not using a REALTOR® or Brokerage.</p>`,
      },
      {
        x: `25%`,
        y: `92%`,
        data: `<p>As with most other pages within the Contract, have ALL of your 
        clients initial on the line that applies.</p>`,
      },
    ],
  },
  {
    id: 1278,
    form: `agri-purchase-contract`,
    page: `8`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-8.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Authorization of Other Party:</strong> If the Seller 
        or Buyer does not have a Brokerage (meaning the are not using a 
         REALTOR® or Brokerage), they must name someone else to 
        receive important documents and notices on their behalf. According to 
        section 14.3, if this information changes, the other party must be 
        notified in writing of the updated details as soon as the change occurs.
        </p>`,
      },
      {
        x: `1%`,
        y: `28%`,
        data: `<p><strong>Confirmation of Contract Terms:</strong>  In short, this section states 
        that this contract is the complete and final Agreement. If it's not 
        written in here, it's not part of the deal...even if someone said it before 
        signing. At the bottom of this section, have your clients initial on the line 
        that applies. Their initials signify that they understand the statements made
        in this section. 
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Legal Obligations Begin:</strong> This section states 
        that the contract is official once it's delivered. After that, 
        the Buyer and Seller---and anyone who legally steps into their 
        place must follow what the contract says.
        </p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Offer:</strong> In this section, the Buyer offers to buy the property with the 
        specified terms of this contract. 
        The offer can only be accepted in writing before the specified date and 
        time, which will be filled in here. If there are multiple Buyers, 
        complete the information as shown in the example provided. For this contract, 
        insert the Buyer's GST #, if applicable.
        </p>`,
      },
    ],
  },
  {
    id: 1279,
    form: `agri-purchase-contract`,
    page: `9`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-9.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Acceptance:</strong> If the Seller chooses to accept based on the terms of the 
        contract, complete this section. It is imperative that the time of 
        acceptance occurs before the time set in Section 17. If there are 
        multiple Sellers, complete the information as shown in the example 
        provided. For this contract, 
        insert the Seller's GST #, if applicable.</p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p>If Dower Rights apply, complete the section here and have the 
        non-owner spouse sign in the specified location.</p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p><strong>Rejection:</strong> This section should be 
        completed if the Seller does not agree to the offer or counteroffer 
        made by the Buyer and does not intend to make a counteroffer.</p>`,
      },
    ],
  },
  {
    id: 12710,
    form: `agri-purchase-contract`,
    page: `10`,
    imageURL:
      "../../images/Yukon/forms/agricultural/agri-purchase-contract-10.png",
    description: `<p>This form is used to consent to the payment of a referral 
    fee. Please note that the "Referred From" and "Referred To" sections refer 
    to the direction of the client referral, not the flow of the fee.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Contract Number:</strong> The Contract Number  
        can be your own personal identifier for this specific agreement.   
        </p>`,
      },
      {
        x: `1%`,
        y: `11%`,
        data: `<p><strong>Conveyancing Information:</strong> If the information 
        is available, please complete this section with your client's 
        details as well as their lawyer's. If it is not available at the 
        time of the offer, it can be provided to the other party at a 
        later date.</p>`,
      },
    ],
  },
];

export default FormPageData;
